webpackJsonp([12,2],{

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./communes/communes.less": 1686,
	"./incentive/taelys-incentive.less": 1687,
	"./old-ie/old-ie.less": 1688,
	"./presentation/copyright-popin.less": 1689,
	"./presentation/presentation-popin.less": 1690,
	"./social/social-buttons.less": 1691
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1019;

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./communes/communes.js": 2547,
	"./incentive/obsTaelysIncentive.js": 2548,
	"./presentation/addPresentationButton.js": 2549,
	"./presentation/addTaelysWatermark.js": 2550,
	"./presentation/obsCopyrightPopin.js": 2551,
	"./presentation/obsPresentationButton.js": 2552,
	"./presentation/obsPresentationPopin.js": 2553,
	"./presentation/obsPresentationPopinCtrl.js": 2554,
	"./presentation/obsTaelysWatermark.js": 2555,
	"./social/addSocialButtons.js": 2556,
	"./social/obsSocialFacebookButton.js": 2557,
	"./social/obsSocialLinkedinButton.js": 2558,
	"./social/obsSocialTwitterButton.js": 2559,
	"./structure/observatoireTopBar.js": 2560
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1020;

/***/ }),

/***/ 1686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/communes', {
    topbarKey: "COMMUNES",
    controller: 'ObservatoireCommunesController',
    template: __webpack_require__(3574)
  });
}]);
ngModule.controller('ObservatoireCommunesController', ["$scope", "obsPresentationPopin", "obsUtils", function ($scope, obsPresentationPopin, obsUtils) {
  $scope.observatoryConfig = {
    publicObs: true,
    resourceBaseUrl: "/rest/public/observatoire/commune"
  };
  $scope.communeParams = {
    observatoire: 'OBSERVATOIRE_DETTE_COMMUNE',
    zonage: 'DEPARTEMENT',
    datatype: 'ENCOURS_DETTE',
    parHabitant: true,
    representation: 'ABSOLU',
    unite: 'VALEUR',
    temporalite: 'INSTANTANE',
    anneeInstantane: obsUtils.getDerniereAnneeDispo(),
    anneeDebut: obsUtils.getDerniereAnneeDispo() - 1,
    anneeFin: obsUtils.getDerniereAnneeDispo(),
    populationMin: null,
    populationMax: null
  };
  obsPresentationPopin.openIfFirstTime();
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/communes/communes.js"))

/***/ }),

/***/ 2548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsTaelysIncentive", ["$interval", "$window", function ($interval, $window) {
  var CAROUSEL_INTERVAL_DELAY = 6500;
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3575),
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.startCarousel();
      $scope.redirectToCommuneInfoPage = function () {
        $window.location.href = "https://www.taelys.com?pageId=offreSecteurPublic";
      };
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this;
      var currentItemIdx = -1,
        carouselEl = $element.find(".carousel"),
        carouselItems = carouselEl.find(".carousel-item");
      ctrl.startCarousel = function () {
        carouselItems.hide();
        ctrl.switchToItem(0);
        startInterval();
      };
      ctrl.switchToItem = function (itemIdx) {
        var scrollHeight = carouselEl.height();
        if (currentItemIdx > -1) {
          var previousItem = carouselItems.eq(currentItemIdx);
          previousItem.animate({
            top: "-=" + scrollHeight + "px"
          }, 500, "easeInOutCubic", function () {
            previousItem.hide();
          });
        }
        var nextItem = carouselItems.eq(itemIdx);
        nextItem.css({
          position: "absolute",
          top: "+" + scrollHeight + "px"
        }).show().animate({
          top: "-=" + scrollHeight + "px"
        }, 500, "easeInOutCubic");
        currentItemIdx = itemIdx;
      };
      ctrl.switchToNext = function () {
        var nextIdx = currentItemIdx === carouselItems.length - 1 ? 0 : currentItemIdx + 1;
        ctrl.switchToItem(nextIdx);
      };
      var startInterval = function startInterval() {
        $interval(function () {
          ctrl.switchToNext();
        }, CAROUSEL_INTERVAL_DELAY);
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/incentive/obsTaelysIncentive.js"))

/***/ }),

/***/ 2549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("addPresentationButton", ["$timeout", "leafletPresentationButton", function ($timeout, leafletPresentationButton) {
  return {
    restrict: "A",
    require: "obsLeafletMap",
    link: function link($scope, $el, $attrs, mapCtrl) {
      var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
        if (mapConfig != null) {
          unwatch();
          $timeout(function () {
            addPresentationButton();
          }, 1);
        }
      });
      var addPresentationButton = function addPresentationButton() {
        mapCtrl.getMap().then(function (map) {
          var watermark = new leafletPresentationButton();
          map.addControl(watermark);
        });
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/addPresentationButton.js"))

/***/ }),

/***/ 2550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("addTaelysWatermark", ["$timeout", "leafletTaelysWatermark", function ($timeout, leafletTaelysWatermark) {
  return {
    restrict: "A",
    require: "obsLeafletMap",
    link: function link($scope, $el, $attrs, mapCtrl) {
      var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
        if (mapConfig != null) {
          unwatch();
          $timeout(function () {
            addWatermark();
          }, 1);
        }
      });
      var addWatermark = function addWatermark() {
        mapCtrl.getMap().then(function (map) {
          var watermark = new leafletTaelysWatermark();
          map.addControl(watermark);
        });
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/addTaelysWatermark.js"))

/***/ }),

/***/ 2551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("obsCopyrightPopin", ["$modal", function ($modal) {
  return {
    open: function open() {
      return $modal.open({
        template: __webpack_require__(3576),
        options: {
          width: 850
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/obsCopyrightPopin.js"))

/***/ }),

/***/ 2552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsPresentationButton", ["obsPresentationPopin", function (obsPresentationPopin) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3577),
    link: function link($scope, $el, $attrs) {
      $scope.openPresentationPopin = function () {
        obsPresentationPopin.open();
      };
    }
  };
}]);
ngModule.factory("leafletPresentationButton", ["$rootScope", "leaflet", "directiveUtils", function ($rootScope, leaflet, directiveUtils) {
  leaflet.Control.ObsPresentationButton = leaflet.Control.extend({
    options: {
      position: 'topleft'
    },
    onAdd: function onAdd(map) {
      var linkFn = directiveUtils.compileDirective("obsPresentationButton");
      var watermark = linkFn($rootScope);
      return watermark[0];
    }
  });
  return leaflet.Control.ObsPresentationButton;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/obsPresentationButton.js"))

/***/ }),

/***/ 2553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("obsPresentationPopin", ["$modal", "$localStorage", function ($modal, $localStorage) {
  var POPIN_OPENED_KEY = "obsPopinOpened";
  var openPopin = function openPopin() {
    return $modal.open({
      controller: "obsPresentationPopinCtrl",
      template: __webpack_require__(3578),
      options: {
        width: 850
      }
    });
  };
  return {
    openIfFirstTime: function openIfFirstTime() {
      if (!$localStorage.getItem(POPIN_OPENED_KEY)) {
        openPopin();
        $localStorage.setItem(POPIN_OPENED_KEY, true);
      }
    },
    open: function open() {
      return openPopin();
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/obsPresentationPopin.js"))

/***/ }),

/***/ 2554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.controller("obsPresentationPopinCtrl", ["$scope", "obsUtils", function ($scope, obsUtils) {
  $scope.derniereAnnee = obsUtils.getDerniereAnneeDispo();
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/obsPresentationPopinCtrl.js"))

/***/ }),

/***/ 2555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsTaelysWatermark", ["obsCopyrightPopin", function (obsCopyrightPopin) {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3579),
    link: function link($scope, $el, $attrs) {
      $scope.openCopyrightPopin = function () {
        obsCopyrightPopin.open();
      };
    }
  };
}]);
ngModule.factory("leafletTaelysWatermark", ["$rootScope", "leaflet", "directiveUtils", function ($rootScope, leaflet, directiveUtils) {
  leaflet.Control.TaelysWatermark = leaflet.Control.extend({
    options: {
      position: 'bottomright'
    },
    onAdd: function onAdd(map) {
      var linkFn = directiveUtils.compileDirective("obsTaelysWatermark");
      var watermark = linkFn($rootScope);
      return watermark[0];
    }
  });
  return leaflet.Control.TaelysWatermark;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/presentation/obsTaelysWatermark.js"))

/***/ }),

/***/ 2556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("addSocialButtons", ["leaflet", "$timeout", "$compile", function (leaflet, $timeout, $compile) {
  return {
    restrict: "A",
    require: "obsLeafletMap",
    link: function link($scope, $el, $attrs, mapCtrl) {
      var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
        if (mapConfig != null) {
          unwatch();
          $timeout(function () {
            addSocialButtons();
          }, 1);
        }
      });
      var addSocialButtons = function addSocialButtons() {
        mapCtrl.getMap().then(function (map) {
          var control = leaflet.control({
            position: "topright"
          });
          control.onAdd = function () {
            var content = $("<div class='social-buttons'>" + "   <obs-social-linkedin-button></obs-social-linkedin-button>" + "   <obs-social-facebook-button></obs-social-facebook-button>" + "   <obs-social-twitter-button></obs-social-twitter-button>" + "</div>");
            $compile(content)($scope);
            return content[0];
          };
          map.addControl(control);
        });
      };
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/social/addSocialButtons.js", __webpack_require__(4)))

/***/ }),

/***/ 2557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSocialFacebookButton", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3580),
    link: function link($scope, $el, $attrs) {
      $('<div id="fb-root"></div>').appendTo(document.body);
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v2.4&appId=1621263301487516";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      $('<div class="fb-share-button" data-layout="button"></div>').appendTo($el);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/social/obsSocialFacebookButton.js", __webpack_require__(4)))

/***/ }),

/***/ 2558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSocialLinkedinButton", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3581),
    link: function link($scope, $el, $attrs) {
      $('<script src="//platform.linkedin.com/in.js" type="text/javascript">lang: fr_FR</script>' + '<script type="IN/Share"></script>').appendTo($el);
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/social/obsSocialLinkedinButton.js", __webpack_require__(4)))

/***/ }),

/***/ 2559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSocialTwitterButton", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(3582),
    link: function link($scope, $el, $attrs) {
      !function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0],
          p = /^http:/.test(d.location) ? 'http' : 'https';
        if (!d.getElementById(id)) {
          js = d.createElement(s);
          js.id = id;
          js.src = p + '://platform.twitter.com/widgets.js';
          fjs.parentNode.insertBefore(js, fjs);
        }
      }(document, 'script', 'twitter-wjs');
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/social/obsSocialTwitterButton.js"))

/***/ }),

/***/ 2560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("observatoireTopBar", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: __webpack_require__(3583),
    controller: ["$scope", "security", function controller($scope, security) {
      $scope.exit = function () {
        security.exit();
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/apps/observatoire/ng/structure/observatoireTopBar.js"))

/***/ }),

/***/ 2561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

var module = angular.module('tael.app.observatoire', [__webpack_require__(7), __webpack_require__(821)]);
module.constant('$APP_NAME', 'OBSERVATOIRE');
module.config(["$routeProvider", "$locationProvider", "$qProvider", function ($routeProvider, $locationProvider, $qProvider) {
  $routeProvider.otherwise({
    redirectTo: '/communes'
  });
  $locationProvider.html5Mode(true);
  $locationProvider.hashPrefix('!');

  //$qProvider.errorOnUnhandledRejections(false);
}]);
module.config(["initialisationServiceProvider", function (initialisationServiceProvider) {
  /*
  // load user and compte from server
  initialisationServiceProvider.addInitialisationHandler(["$session", "$authz", "$q", function($session, $authz, $q) {
      return $q.when($session.$load()).then(function() {
          return $authz.$setUser($session.getUser(), $session.getHabilitations());
      });
  }]);
  */

  // load translations from server
  initialisationServiceProvider.addInitialisationHandler(["$translate", "indexationService", function ($translate) {
    return $translate.init({
      url: "/rest/translations/observatoire",
      lang: "fr"
    });
  }]);

  // load currencies
  initialisationServiceProvider.addInitialisationHandler(["currencyService", function (currencyService) {
    return currencyService.$load();
  }]);

  // load application settings
  initialisationServiceProvider.addInitialisationHandler(["applicationSettings", function (applicationSettings) {
    return applicationSettings.$load();
  }]);
}]);
module.run(["security", "initialisationService", function (security, initialisationService) {
  security.initAuthentication();
  initialisationService.executeHandlers();
}]);

// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
  context.keys().forEach(context);
}
requireAllInContext(__webpack_require__(1020));
requireAllInContext(__webpack_require__(1019));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 3574:
/***/ (function(module, exports) {

module.exports = "<div class=abs-full-size obs-map-manager obs-commune-manager> <tl-panel-layout panel-opened class=observatoire-carte> <tl-panel-left> <obs-commune-panel></obs-commune-panel> </tl-panel-left> <tl-panel-right autosizing-container sizable-container> <obs-leaflet-map obs-commune-map add-taelys-watermark add-presentation-button add-social-buttons></obs-leaflet-map> </tl-panel-right> </tl-panel-layout> </div> ";

/***/ }),

/***/ 3575:
/***/ (function(module, exports) {

module.exports = "<div class=obs-taelys-incentive> <div class=carousel> <div class=carousel-item> <span>Avec Taelys, les Collectivités maîtrisent la gestion de leur dette et leur relation avec les banques.</span> </div> <div class=carousel-item> <span>Elles disposent de la plateforme Web la plus innovante du marché,</span> </div> <div class=carousel-item> <span>et bénéficient de l’accompagnement d’experts financiers proches du terrain, disponibles et proactifs.</span> </div> <div class=carousel-item> <span>L’assistance de Taelys couvre l’ensemble des besoins en matière d’analyse, d’optimisation de la dette existante,</span> </div> <div class=carousel-item> <span>et d’accompagnement dans la recherche et la mise en place de nouveaux financements.</span> </div> <div class=carousel-item> <span>L’offre Taelys permet : le suivi de la dette propre et de la dette garantie,</span> </div> <div class=carousel-item> <span>la connexion de votre dette aux données de marché et à votre logiciel de gestion financière</span> </div> <div class=carousel-item> <span>la simulation d’impact d’un arbitrage sur votre dette actuelle ou d’un nouveau financement,</span> </div> <div class=carousel-item> <span>la génération automatique des rapports légaux et de tableaux de bord personnalisés...</span> </div> <div class=carousel-item> <span>La proximité et la proactivité de votre consultant sont la clé d’une meilleure maîtrise de vos frais financiers.</span> </div> <div class=carousel-item> <span class=mono-line class=mono-line>N'hésitez pas à nous contacter pour une présentation détaillée</span> </div> </div> <div class=btn-block> <button class=btn-cta ng-click=redirectToCommuneInfoPage()> <i class=\"fa fa-info-circle\"></i> <span>En savoir plus</span> </button> </div> </div>";

/***/ }),

/***/ 3576:
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box obs-copyright-popin\"> <div class=title> <h3>Copyright et mentions légales</h3> </div> <div class=content> <div class=section> <h4>Observatoire Taelys de la dette des communes</h4> <p> Copyright Taelys. Reproduction des données et de captures de la carte autorisée sous condition de citer explicitement Taelys et de fournir un lien vers <a target=_blank href=https://www.taelys.com>https://www.taelys.com</a> ou <a target=_blank href=https://observatoire.taelys.com>http://observatoire.taelys.com</a> </p> </div> <div class=section> <h4>Fond de carte</h4> <p> Copyright OpenStreetMap et les contributeurs OpenStreetMap. License disponible sur <a target=_blank href=http://www.openstreetmap.org/copyright>openstreetmap.org/copyright</a> </p> </div> <div class=section> <h4>Données statistiques des communes</h4> <p> Ministère de l'économie. Plus d'informations sur <a target=_blank href=http://www.collectivites-locales.gouv.fr>collectivites-locales.gouv.fr</a> </p> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close()> Fermer </tl-button> </div> </div>";

/***/ }),

/***/ 3577:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaflet-control obs-presentation-button\" title=\"Afficher la présentation de l'observatoire\" ng-click=openPresentationPopin()> <i class=\"fa fa-info\"></i> </div>";

/***/ }),

/***/ 3578:
/***/ (function(module, exports) {

module.exports = "<div class=\"confirm-box obs-presentation-popin\"> <div class=title> <h3>Bienvenue sur l'observatoire Taelys de la dette des communes</h3> </div> <div class=content> <p class=interline-b>L'observatoire Taelys vous permet de visualiser les données relatives à la dette des 36 800 communes de France métropolitaine depuis 2000</p> <p>Il s'agit d'un observatoire simplifié par rapport à celui proposé à nos abonnés qui disposent de plus de types de données (l'ensemble des données du Compte Administratif, la population DGF), d'un observatoire des EPCIs, des départements, des SDIS, de filtres par strate, et de pages avec tableaux et graphiques d'analyses permettant d'aller plus loin...</p> <div class=taelys> <p class=taelys-title>Taelys accompagne les acteurs du secteur public et privé dans leur gestion de la dette.</p> <p>Pour plus d'informations n'hésitez pas à nous contacter à l'adresse <a href=mailto:contact@taelys.com>contact@taelys.com</a><br/> ou à visiter notre site : <a href=https://www.taelys.com>https://www.taelys.com</a> </p> </div> <h3> Utilisation </h3> <div class=\"pre-section pres-1\"> <p>Recherchez la commune dont vous souhaitez voir les informations financières grâce au champ de recherche situé en haut.</p> <img src=/images/presentation/obs-1.png /> </div> <div class=\"pre-section pres-2\"> <img src=/images/presentation/obs-5.png /> <p>Cette commune est alors automatiquement centrée sur la carte. Le résumé de ses dernières informations clés est affiché dans le panneau de gauche en haut.</p> </div> <div class=\"pre-section pres-3\"> <p> Dans ce même panneau, un formulaire vous permet de choisir l'indicateur que vous souhaitez visualiser sur la carte. <br/> Par défaut, c'est la dette par habitant de l'année {{derniereAnnee}} qui est présentée. </p> <img src=/images/presentation/obs-3.png /> </div> <div class=\"pre-section pres-4\"> <p> Sur la carte apparait votre commune ainsi que toutes celles du département (ou dans son périmètre si vous choisissez l'option de zonage 'Voisinage'). </p> <div class=align-c> <img src=/images/presentation/obs-4.png /> </div> </div> <div class=\"pre-section pres-5\"> <p> Chaque commune apparait dans une couleur plus ou moins sombre en fonction de son niveau par rapport à l'indicateur choisi. <br/> En bas à gauche, une zone affiche les informations de l'indicateur choisi : La valeur pour la commune choisie est affichée en violet, celle de la commune survolée en orange.<br/> Sont également affichées : </p> <ul class=list> <li>la moyenne pour les communes françaises de la même strate de population,</li> <li>la moyenne pour les communes du département,</li> <li>la moyenne nationale.</li> </ul> <p> La légende en bas à droite vous permet de connaitre les plages de valeurs couvertes par chaque couleur. </p> <img src=/images/presentation/obs-2.png /> </div> <div class=\"pre-section pres-6\"> <p class=b>Les indicateurs disponibles sont :</p> <ul class=list> <li>Population : Recensement INSEE</li> <li>Dette, Annuité, Intérêt, Amortissement : Données au 31/12 de chaque année (budget principal uniquement), publiées par le ministère des finances. </li> <li>Dette, Annuité, Intérêt, Amortissement/habitant : Rapport de l'indicateur sur la population</li> <li>Potentiel fiscal par habitant : Ensemble des ressources stables d'une collectivité (capacité de la collectivité à mobiliser des ressources fiscales + dotations d'état récurrentes) </li> <li>Dette sur potentiel fiscal : Nombre de mois qu'il faudrait théoriquement pour rembourser l'ensemble de la dette si tout le potentiel fiscal était utilisé à cela (hors considération de pénalités) </li> <li> Dotations et dotations par habitant : Il s'agit du concours financier de l'état aux collectivités </li> </ul> </div> <div class=\"pre-section pres-7\"> <p class=b>Le panneau vous offre d'autres options de visualisation :</p> <ul class=list> <li> Choix de l'année : les données sont disponibles depuis 2000, à l'exception du potentiel fiscal disponible depuis 2010. </li> <li>Dimension temporelle : l'option \"entre 2 années\" vous permet de voir l'évolution d'un indicateur entre 2 années. </li> <li>Vous pouvez aussi préciser si vous souhaitez voir cette évolution en valeur (ex: +1 000 hab.) ou en pourcentage (+3%). </li> </ul> </div> </div> <div class=footer> <tl-button class=btn-primary ng-click=$close()> Accéder à l'observatoire </tl-button> </div> </div> ";

/***/ }),

/***/ 3579:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaflet-control taelys-watermark\"> <div class=watermark> <img src=/images/logo_taelys.svg /> </div> <a ng-click=openCopyrightPopin() class=copyright-link> <i class=\"fa fa-copyright\"></i> <span>Mentions légales</span> </a> </div>";

/***/ }),

/***/ 3580:
/***/ (function(module, exports) {

module.exports = "<div class=social-facebook-button></div>";

/***/ }),

/***/ 3581:
/***/ (function(module, exports) {

module.exports = "<div class=social-linkedin-button></div>";

/***/ }),

/***/ 3582:
/***/ (function(module, exports) {

module.exports = "<a href=https://twitter.com/share class=twitter-share-button data-count=none> Tweet </a>";

/***/ }),

/***/ 3583:
/***/ (function(module, exports) {

module.exports = "<div class=topbar> <div class=topbar-content> <a class=topbar-logo href=https://www.taelys.com> <img class=taelys-logo src=/images/logo_taelys.svg /> <h3 class=\"app-name no-print\">{{'topbar.appLabel.OBSERVATOIRE' | translate}}</h3> </a> <obs-taelys-incentive></obs-taelys-incentive> </div> </div>";

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

// leaflet
__webpack_require__(20);
__webpack_require__(917);
var MODULE_NAME = 'tael.module.observatoire';
var ngModule = angular.module(MODULE_NAME, [
//require("../common/common-module"),
'leaflet-directive' // OpenStreetMap
]);

// Warning : do NOT factorize this : webpack will not be able to parse parametrized context paths.
function requireAllInContext(context) {
  context.keys().forEach(context);
}
requireAllInContext(__webpack_require__(893));
requireAllInContext(__webpack_require__(892));
module.exports = MODULE_NAME;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 847:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _, angular) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsLeafletMap", ["$q", "$timeout", "leafletDefaultConfig", function ($q, $timeout, leafletDefaultConfig) {
  return {
    restrict: "E",
    scope: true,
    require: ["obsLeafletMap", "^obsMapManager"],
    replace: true,
    template: __webpack_require__(882),
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapManagerCtrl = controllers[1];
      ctrl.initialize(mapManagerCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        updateHandler = null,
        managerCtrl = null;
      ctrl.initialize = function (_managerCtrl) {
        managerCtrl = _managerCtrl;
        $scope.mapConfig = _.extend(angular.copy(leafletDefaultConfig), {});
        ctrl.listenToEvents();
      };
      ctrl.listenToEvents = function () {
        $scope.$on("obs:data-load:start", function () {
          ctrl.showLoader();
        });
        $scope.$on("obs:data-load:success", function (e, mapData) {
          ctrl.updateMapData(mapData);
          ctrl.hideLoader();
        });
      };
      ctrl.updateMapData = function (mapData) {
        if (updateHandler != null) {
          updateHandler(mapData);
        }
      };
      ctrl.showLoader = function () {
        ctrl.getMap().then(function (map) {
          map.loaderControl.showLoader();
        });
      };
      ctrl.hideLoader = function () {
        $timeout(function () {
          // parfois ctrl non défini (sur une destruction sans doute)...
          if (ctrl != null) {
            var res = ctrl.getMap();
            if (res != null) {
              res.then(function (map) {
                map.loaderControl.hideLoader();
              });
            }
          }
        }, 0, false);
      };
      ctrl.setUpdateHandler = function (handler) {
        updateHandler = handler;
      };

      /**
       * @return {Promise}
       */
      ctrl.getMap = function () {
        var mapElement = $element.find(".angular-leaflet-map"),
          mapController = mapElement.controller("leaflet");
        if (mapController) {
          return $q.when(mapController.getMap());
        } else {
          return $q.reject({});
        }
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/common/obsLeafletMap.js", __webpack_require__(1), __webpack_require__(3)))

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsMapManager", function () {
  return {
    restrict: "A",
    controllerAs: "mapManagerCtrl",
    scope: true,
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.initialize();
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this;
      ctrl.initialize = function () {};
      ctrl.setViewport = function (_viewport) {
        $scope.viewport = _viewport;
      };
      ctrl.getViewport = function () {
        return $scope.viewport;
      };
    }]
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/common/obsMapManager.js"))

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsMapShortcut", function () {
  return {
    restrict: "E",
    scope: true,
    replace: true,
    template: __webpack_require__(883)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/common/obsMapShortcut.js"))

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// http://www.toolserver.org/tiles/bw-mapnik/${z}/${x}/${y}.png
// http://www.toolserver.org/tiles/bw-mapnik/{z}/{x}/{y}.png
// http://tile.openstreetmap.us/vectiles-water-areas/{z}/{x}/{y}.mvt
// http://www.naturalearthdata.com/downloads/110m-physical-vectors/
// http://gis.stackexchange.com/questions/1617/rendering-custom-openstreetmaps-style-land-white-water-black-do-i-need-a-ded
// http://mc.bbbike.org/mc/?lon=-1.33386&lat=47.15491&zoom=11&num=2&mt0=mapnik
// http://tile.openstreetmap.fr/

ngModule.run(["leaflet", function (leaflet) {
  // setting leaflet default paths
  leaflet.Icon.Default.imagePath = "/images/leaflet";
}]);
ngModule.run(["applicationSettings", "leafletDefaultConfig", function (applicationSettings, leafletDefaultConfig) {
  applicationSettings.get().then(function (settings) {
    if (settings.leafletTilesUrl) {
      leafletDefaultConfig.tiles.url = settings.leafletTilesUrl;
    }
  });
}]);
ngModule.factory("leafletDefaultConfig", function () {
  var worldMaxBounds = {
    northEast: {
      lat: 90,
      lng: 180
    },
    southWest: {
      lat: -90,
      lng: -180
    }
  };
  return {
    options: {
      minZoom: 4,
      maxZoom: 12,
      attributionControl: false,
      tileLayerOptions: {
        attribution: '&copy; <a href="https://www.taelys.com">Taelys</a> | &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }
    },
    maxbounds: worldMaxBounds,
    tiles: {
      url: 'https://tiles.taelys.com/{z}/{x}/{y}.png'
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/leaflet/leaflet-config.js"))

/***/ }),

/***/ 852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);




/*
 * L.Control.Loading is a control that shows a loading indicator when tiles are
 * loading or when map-related AJAX requests are taking place.
 */

(function () {
  //var L = window.L;

  // https://github.com/ebrelsford/Leaflet.loading/blob/master/src/Control.Loading.js

  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Control.Loading = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Control.extend({
    options: {
      position: 'topright'
    },
    initialize: function initialize(options) {
      __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.setOptions(this, options);
      this._loading = false;
    },
    onAdd: function onAdd(map) {
      this._loader = $('<div>').addClass('leaflet-control-geoloader').hide();
      return this._loader[0];
    },
    onRemove: function onRemove(map) {},
    isLoading: function isLoading() {
      return this._loading;
    },
    showLoader: function showLoader() {
      this._loader.show();
      this._loading = true;
    },
    hideLoader: function hideLoader() {
      this._loader.hide();
      this._loading = false;
    }
  });

  // adding init hooks

  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Map.addInitHook(function () {
    this.loaderControl = new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Control.Loading();
    this.addControl(this.loaderControl);
  });
  __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Control.loading = function (options) {
    return new __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.Control.Loading(options);
  };
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, L) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("leafletUtils", ["directiveUtils", function (directiveUtils) {
  return {
    addShortcuts: function addShortcuts(scope, element, leaflet, map) {
      var shortcuts;
      var corners = map._controlCorners,
        l = 'leaflet-',
        container = map._controlContainer;
      function createCorner(vSide, hSide) {
        var className = l + vSide + ' ' + l + hSide;
        corners[vSide + hSide] = L.DomUtil.create('div', className, container);
      }
      createCorner('verticalcenter', 'left');
      var linkFn = directiveUtils.compileDirective("obsMapShortcut");
      var contentEl = null;
      linkFn(scope, function (clone) {
        clone.appendTo(element);
        contentEl = clone;
      });
      shortcuts = leaflet.control({
        position: "verticalcenterleft"
      });
      shortcuts.onAdd = function () {
        return contentEl[0];
      };
      shortcuts.addTo(map);
      contentEl[0].addEventListener("MapFocus", function (e) {
        map.flyTo(e.detail.location, e.detail.zoom, {
          animate: true,
          duration: 3
        });
      }, false);
      return shortcuts;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/leaflet/leaflet-utils.js", __webpack_require__(20)))

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("leaflet", function () {
  return __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/leaflet/leaflet.js"))

/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsCommuneManager", ["$q", "$http", "$debounce", "obsUtils", function ($q, $http, $debounce, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ['obsCommuneManager', 'obsMapManager'],
    controllerAs: "communeManagerCtrl",
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapManagerCtrl = controllers[1],
        obsConfig = $scope.observatoryConfig;
      ctrl.initialize(obsConfig, mapManagerCtrl);
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        config = null,
        mapManagerCtrl = null,
        requestCanceler = null,
        selectedId = null,
        referenceId = null,
        hoveredCommune = null;
      //var reperes = [];
      ctrl.initialize = function (_config, _mapManagerCtrl) {
        config = _config;
        mapManagerCtrl = _mapManagerCtrl;
        ctrl.loadReference();
        mapManagerCtrl.setViewport({
          lat: 46.8,
          lng: 2.25,
          zoom: 6
        });

        // $http.post(config.resourceBaseUrl + "/map-data-reperes").then(function(response) {
        //     reperes = response.data;
        //     startWatching();
        // });
        startWatching();
      };
      ctrl.getConfig = function () {
        return config;
      };
      var startWatching = function startWatching() {
        $scope.$watch('viewport', function (view) {
          ctrl.refreshData();
        }, true);
        $scope.$watch('communeParams', function () {
          // TODO : rename to generic
          if ($scope.communeParams.temporalite !== "EVOLUTION" && $scope.communeParams.representation !== "RELATIF") {
            $scope.communeParams.unite = "VALEUR";
          }
          ctrl.refreshData();
        }, true);
      };
      ctrl.setHoveredCommune = function (commune) {
        hoveredCommune = commune;
      };
      ctrl.getHoveredCommune = function () {
        return hoveredCommune;
      };

      /**
       *
       * @param commune
       */
      ctrl.setReferenceCommune = function (commune) {
        ctrl.loadReference(commune.id).then(function () {
          // nothing ?
        });
      };
      ctrl.onSearchFieldSelection = function (entity) {
        if (config.publicObs) {
          ctrl.setReferenceCommune(entity);
        } else {
          ctrl.centerMapOn(entity);
        }
      };
      ctrl.centerMapOn = function (entity) {
        selectedId = entity.id;
        mapManagerCtrl.setViewport({
          lat: entity.coordinates.lat,
          lng: entity.coordinates.lng,
          zoom: 10
        });
      };
      ctrl.getSelectedId = function () {
        return selectedId;
      };
      ctrl.setSelectedId = function (entityId) {
        selectedId = entityId;
      };

      /**
       * Load reference from server, either from given code insee, or defaulting to geoloc if insee is null or invalid.
       */
      ctrl.loadReference = function (refIdToLoad, centerOnMap) {
        // set empty default if none
        if ($scope.reference == null) {
          $scope.reference = {
            id: null,
            name: "Pas de référence",
            coordinates: null
          };
        }
        // then load
        return $http.get(config.resourceBaseUrl + "/reference", {
          params: {
            year: $scope.communeParams.anneeInstantane,
            id: refIdToLoad
          }
        }).then(function (response) {
          var reference = response.data;
          referenceId = reference.id;
          $scope.reference = reference;
          if (reference.coordinates) {
            // ne pas recentrer évite de recharger les contours, a ne faire que si les contours sont déjà là, c'est à dire sur un click de contour
            if (centerOnMap !== false) {
              ctrl.centerMapOn(reference);
            }
          }
        });
      };
      ctrl.refreshData = $debounce(function () {
        if (requestCanceler) {
          requestCanceler.resolve();
        }
        requestCanceler = $q.defer();
        $scope.$broadcast("obs:data-load:start");
        var viewport = mapManagerCtrl.getViewport();
        var mapDataParams = _.extend({}, $scope.communeParams, {
          referenceId: $scope.communeParams.referenceId || referenceId,
          position: {
            lat: viewport.lat,
            lng: viewport.lng
          }
        });
        $http.post(config.resourceBaseUrl + "/map-data", mapDataParams, {
          timeout: requestCanceler.promise
        }).then(function (response) {
          var infoCommune = response.data;

          // // les reperes doivent etre inséré avant les données des communes
          // if (reperes) {
          //     infoCommune.features= reperes.concat(infoCommune.features);
          // }

          // TODO : clean this
          // Toujours la valeur absolue pour l'affichage de la valeur de référence
          var formatParameters = _.extend({}, $scope.communeParams, {
            representation: 'ABSOLU'
          });

          // quand on est en instantané, toujours en VALEUR pour les valeurs de ref.
          if ($scope.communeParams.temporalite === 'INSTANTANE') {
            formatParameters.unite = 'VALEUR';
          }
          $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
          $scope.referenceValue = obsUtils.formatValue(formatParameters, infoCommune.referenceValue);
          $scope.departementValue = obsUtils.formatValue(formatParameters, infoCommune.departementValue);
          $scope.departementCodeInsee = infoCommune.departementCodeInsee;
          $scope.strateValue = obsUtils.formatValue(formatParameters, infoCommune.strateValue);
          $scope.strate = obsUtils.getStrateLabel(infoCommune.strate);
          $scope.paysValue = obsUtils.formatValue(formatParameters, infoCommune.paysValue);
          // TODO : end

          $scope.$broadcast("obs:data-load:success", infoCommune);
        });
      }, 250);
      $scope.$on("$destroy", function () {
        // cancel the currently waiting debounced call, if it exists.
        ctrl.refreshData.cancel();
        if (requestCanceler != null) {
          requestCanceler.resolve();
        }
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommuneManager.js", __webpack_require__(1)))

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _, L) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsCommuneMap", ["leaflet", "leafletDefaultConfig", "leafletUtils", "ObsStratManager", "directiveUtils", "$timeout", "obsUtils", function (leaflet, leafletDefaultConfig, leafletUtils, ObsStratManager, directiveUtils, $timeout, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ["obsCommuneMap", "obsLeafletMap", "^obsCommuneManager"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapCtrl = controllers[1],
        mapManagerCtrl = controllers[2];
      mapCtrl.setUpdateHandler(ctrl.updateData);
      ctrl.initialize(mapCtrl, mapManagerCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        mapCtrl = null,
        managerCtrl = null;
      var geoManager = new ObsStratManager({}),
        geoConfig = geoManager.getConfig();
      ctrl.initialize = function (_mapCtrl, _managerCtrl) {
        mapCtrl = _mapCtrl;
        managerCtrl = _managerCtrl;

        // need to wait for the map to be here... didnt found a proper way, so we watch the same condition once.
        var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
          if (mapConfig != null) {
            unwatch();
            $timeout(addSearchFieldControl, 1);
          }
        });
      };
      var legend, searchControl, shortcuts, contextInfo, tooltipElement, selectedLayer;
      ctrl.updateData = function (infoCommune) {
        mapCtrl.getMap().then(function (map) {
          if (shortcuts == null) {
            shortcuts = leafletUtils.addShortcuts($scope, $element, leaflet, map);
          }

          // initialize contextInfo
          if (contextInfo == null) {
            addContextInfoControl(map);
          }
          if (tooltipElement == null) {
            createTooltipElement();
          }

          // refresh manager
          geoManager.setStrates(infoCommune.strates);

          // create legend
          if (legend != null) {
            legend.remove();
          }
          legend = geoManager.generateLegend();
          map.addControl(legend);

          // creates geojson layout
          generateGeoJson(map, infoCommune);
        });
      };
      var addContextInfoControl = function addContextInfoControl(map) {
        var linkFn = directiveUtils.compileDirective("obsCommuneMapContextInfo");
        var contentEl = null;
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          contentEl = clone;
        });
        contextInfo = leaflet.control({
          position: "bottomleft"
        });
        contextInfo.onAdd = function () {
          return contentEl[0];
        };
        contextInfo.addTo(map);
      };
      var createTooltipElement = function createTooltipElement() {
        var linkFn = directiveUtils.compileDirective("obsCommuneMapTooltip");
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          tooltipElement = clone[0];
        });
      };
      var addSearchFieldControl = function addSearchFieldControl() {
        mapCtrl.getMap().then(function (map) {
          searchControl = leaflet.control({
            position: "topleft"
          });
          searchControl.onAdd = function () {
            var searchWrapper = $("<div>").addClass("leaflet-control-search-field");
            var searchFieldLink = directiveUtils.compileDirective("obsCommuneSearchField");
            var searchField;
            searchFieldLink($scope, function (_searchField) {
              searchField = _searchField;
              searchField.appendTo($element);
            });
            searchField.appendTo(searchWrapper);
            // avoid scrolling map when in widget
            _.each(["mousedown", "mouseup", "mousewheel"], function (eventName) {
              searchWrapper.bind(eventName, function (e) {
                e.stopPropagation();
              });
            });
            return searchWrapper[0];
          };
          searchControl.addTo(map);
        });
      };
      var generateGeoJson = function generateGeoJson(map, infoMapCommune) {
        var getSelectedId = function getSelectedId() {
          return managerCtrl.getSelectedId();
        };

        // Afficher les nom et données sur la carte directement
        if ($scope.labels) {
          var _iterator = _createForOfIteratorHelper($scope.labels),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var label = _step.value;
              map.removeLayer(label);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        $scope.labels = [];
        _.extend($scope, {
          geojson: {
            data: infoMapCommune.features,
            onEachFeature: function onEachFeature(feature, layer) {
              var featureId = feature.properties.id;
              var style = geoManager.getGeoStyle(feature);
              if (featureId === getSelectedId()) {
                selectedLayer = layer;
                _.extend(style, geoConfig.selectedStyle);
              }
              if ($scope.reference != null && featureId === $scope.reference.id) {
                _.extend(style, geoConfig.referenceStyle);
              }
              layer.setStyle(style);
              layer.bindTooltip(tooltipElement, {
                sticky: true,
                direction: 'right',
                offset: [20, 0]
              });

              // Afficher les nom et données sur la carte directement
              // ajout de labels
              if ($scope.communeParams.label && map.getZoom() > 10) {
                var value = feature.properties.value;
                value = obsUtils.formatValue($scope.communeParams, value);
                var label = L.marker(layer.getBounds().getCenter(), {
                  icon: L.divIcon({
                    className: 'label-layer-carto',
                    html: '<div class="detail-carto"><div>' + feature.properties.nom + '</div><div>' + value + '</div></div>',
                    iconSize: [100, 40]
                  })
                }).addTo(map);
                $scope.labels.push(label);
              }
              layer.on("click", function (e) {
                // uniquement pour le public : changement de référence sur le click (egalement sur sytale+)
                if (managerCtrl.getConfig().publicObs) {
                  selectArea(featureId, layer);
                  // sur le public, on ne recentre pas sur la référence suite au click pour ne pas déclencher de rechargement des contours
                  managerCtrl.loadReference(featureId, false);
                  managerCtrl.refreshData(); // La valeur pour la référence doit être mise à jour (TAEL-1163)
                } else if (featureId === getSelectedId()) {
                  managerCtrl.setSelectedId(null);
                  selectedLayer = null;
                  layer.setStyle(geoConfig.defaultStyle);
                } else {
                  selectArea(featureId, layer);
                }
              });
              layer.on("mouseover", function (e) {
                managerCtrl.setHoveredCommune(feature.properties);
                layer.setStyle(geoConfig.hoverStyle);
              });
              layer.on("mouseout", function (e) {
                managerCtrl.setHoveredCommune(null);
                if ($scope.reference != null && featureId === $scope.reference.id) {
                  layer.setStyle(geoConfig.referenceStyle);
                } else if (featureId === getSelectedId()) {
                  layer.setStyle(geoConfig.selectedStyle);
                } else {
                  layer.setStyle(geoConfig.defaultStyle);
                }
              });
            }
          }
        });
        var selectArea = function selectArea(featureId, layer) {
          if (selectedLayer) {
            selectedLayer.setStyle(geoConfig.defaultStyle);
          }
          managerCtrl.setSelectedId(featureId);
          selectedLayer = layer;
          layer.setStyle(geoConfig.selectedStyle);
        };
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommuneMap.js", __webpack_require__(4), __webpack_require__(1), __webpack_require__(20)))

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
/**
 * zone de contexte en bas à gauche (nom, moyennes, ...)
 */
ngModule.directive("obsCommuneMapContextInfo", function () {
  return {
    restrict: "E",
    require: "^obsCommuneManager",
    scope: true,
    replace: true,
    template: __webpack_require__(884)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommuneMapContextInfo.js"))

/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsCommuneMapTooltip", ["obsUtils", function (obsUtils) {
  return {
    restrict: "E",
    require: "^obsCommuneManager",
    scope: true,
    replace: true,
    template: "\n        <div class=\"leaflet-control control obs-map-tooltip\">\n            <div class=\"hovered-name\">{{hoverName}}</div>\n            <div class=\"hovered-value\">\n                {{referenceLabel}}: {{hoverValue}}\n            </div>\n        </div>",
    link: function link($scope, $el, $attrs, managerCtrl) {
      $scope.$watch(function () {
        return managerCtrl.getHoveredCommune();
      }, function (hoveredCommune) {
        if (hoveredCommune == null) {
          $scope.hoverName = null;
          $scope.hoverValue = null;
        } else {
          $scope.hoverName = hoveredCommune.nom;
          $scope.hoverValue = obsUtils.formatValue($scope.communeParams, hoveredCommune.value);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommuneMapTooltip.js"))

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsCommunePanel", ["applicationSettings", "$translate", "$http", "obsPanelService", "obsUtils", function (applicationSettings, $translate, $http, obsPanelService, obsUtils) {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(885),
    link: function link($scope, $el, $attrs) {
      $scope.optionsCollapsed = false;
      $scope.filtresCollapsed = true;
      applicationSettings.get().then(function (settings) {
        if (settings.deployment) {
          var isTaelDeployment = settings.deployment === 'tael';
          $scope.datatypes = [{
            name: $translate('observatoire.datatype.Dette'),
            value: 'ENCOURS_DETTE'
          }];
          if (isTaelDeployment) {
            $scope.datatypes.push({
              name: $translate('observatoire.datatype.Annuite'),
              value: 'ANNUITE_DETTE'
            }, {
              name: $translate('observatoire.datatype.Amortissement'),
              value: 'AMORTISSEMENT_DETTE'
            }, {
              name: $translate('observatoire.datatype.Interet'),
              value: 'INTERET_DETTE'
            });
          }
          $scope.datatypes.push({
            name: $translate('observatoire.datatype.Dotations'),
            value: 'DOTATION_GLOBALE_FONCTIONNEMENT'
          });
          if (isTaelDeployment) {
            $scope.datatypes.push({
              name: $translate('observatoire.datatype.RecetteDeFonctionnement'),
              value: 'RECETTES_FONCTIONNEMENT'
            }, {
              name: $translate('observatoire.datatype.DetteSurRecetteDeFonctionnement'),
              value: 'DETTE_SUR_RECETTES_FONCTIONNEMENT'
            });
          }
          $scope.datatypes.push({
            name: $translate('observatoire.datatype.PotentielFinancier'),
            value: 'POTENTIEL_FINANCIER'
          }, {
            name: $translate('observatoire.datatype.DetteSurPotentielFinancier'),
            value: 'DETTE_SUR_POTENTIEL_FINANCIER'
          }, {
            name: $translate('observatoire.datatype.PopulationDGFIP'),
            value: 'POPULATION_DGFIP'
          }, {
            name: $translate('observatoire.datatype.POPULATION_DGCL_DGF'),
            value: 'POPULATION_DGCL_DGF'
          }
          //  {name: $translate('observatoire.datatype.POPULATION_INSEE'), value: 'POPULATION_INSEE'}
          );
        }
      });
      $scope.sourcesPopulation = [{
        name: 'DGFiP',
        value: 'DGFIP'
      }, {
        name: 'DGF',
        value: 'DGCL_DGF'
      }
      //{name: 'INSEE', value: 'INSEE'},
      ];
      $scope.zonages = [{
        name: $translate('observatoire.zonage.Departement'),
        value: 'DEPARTEMENT'
      }, {
        name: $translate('observatoire.zonage.Voisinage'),
        value: 'VOISINAGE'
      }];
      $scope.isParHab = function (datatype) {
        return !(datatype === 'POPULATION_DGCL_DGF' || datatype === 'POPULATION_INSEE' || datatype === 'POPULATION_DGFIP' || datatype === 'DETTE_SUR_POTENTIEL_FINANCIER' || datatype === 'DETTE_SUR_RECETTES_FONCTIONNEMENT');
      };
      if (!$scope.observatoryConfig.publicObs) {
        $scope.zonages.push({
          name: $translate('observatoire.zonage.Panel'),
          value: 'PANEL'
        });
        obsPanelService.getPanels().then(function (panels) {
          $scope.panels = panels;
          if ($scope.panels.length > 0) {
            $scope.communeParams.panelId = $scope.panels[0].id;
          }
        });
      }
      $scope.representations = [{
        name: $translate('observatoire.representation.Absolu'),
        value: 'ABSOLU'
      }, {
        name: $translate('observatoire.representation.RelatifCommune'),
        value: 'RELATIF'
      }];
      $scope.unites = [{
        name: $translate('observatoire.unite.EnValeur'),
        value: 'VALEUR'
      }, {
        name: $translate('observatoire.unite.EnPourcentage'),
        value: 'POURCENTAGE'
      }];
      $scope.temporalites = [{
        name: $translate('observatoire.temporalite.Instantané'),
        value: 'INSTANTANE'
      }, {
        name: $translate('observatoire.temporalite.Evolution'),
        value: 'EVOLUTION'
      }];
      $scope.anneesDefaut = obsUtils.getAnneesDispo();
      $scope.annees = $scope.anneesDefaut;
      $scope.$watch('communeParams', function () {
        $scope.annees = $scope.anneesDefaut;
        if (!$scope.communeParams.anneeInstantane) {
          $scope.communeParams.anneeInstantane = obsUtils.getDerniereAnneeDispo();
        }
        if (!$scope.communeParams.anneeDebut) {
          $scope.communeParams.anneeDebut = obsUtils.getDerniereAnneeDispo() - 1;
        }
        if (!$scope.communeParams.anneeFin) {
          $scope.communeParams.anneeFin = obsUtils.getDerniereAnneeDispo();
        }
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommunePanel.js"))

/***/ }),

/***/ 860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsCommuneSearchField", function () {
  return {
    restrict: "E",
    require: "^obsCommuneManager",
    replace: true,
    template: '' + '<div class="obs-search-field">' + '   <tl-search-field config="searchConfig"></tl-search-field>' + '</div>',
    link: function link($scope, $el, $attrs, mapManagerCtrl) {
      var obsConfig = $scope.observatoryConfig,
        searchUrl = obsConfig.resourceBaseUrl + "/search";
      $scope.searchExtraParams = {
        actuelsSeulement: true
      };
      $scope.searchConfig = {
        labelAttribute: "nom",
        extraParams: "searchExtraParams",
        searchUrl: searchUrl,
        resultTemplate: "" + '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' + '<span class="dept">{{result.departement}}</span>',
        onSelect: function onSelect(commune) {
          mapManagerCtrl.onSearchFieldSelection(commune);
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/commune/obsCommuneSearchField.js"))

/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementManager", ["$q", "$http", "$debounce", "obsUtils", function ($q, $http, $debounce, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ['obsDepartementManager', 'obsMapManager'],
    controllerAs: "departementManagerCtrl",
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapManagerCtrl = controllers[1],
        obsConfig = $scope.observatoryConfig;
      ctrl.initialize(obsConfig, mapManagerCtrl);
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        config = null,
        mapManagerCtrl = null,
        requestCanceler = null,
        selectedId = null,
        referenceId = null,
        hoveredCommune = null;
      ctrl.initialize = function (_config, _mapManagerCtrl) {
        config = _config;
        mapManagerCtrl = _mapManagerCtrl;
        ctrl.loadReference();
        mapManagerCtrl.setViewport({
          lat: 46.8,
          lng: 2.25,
          zoom: 6
        });
        startWatching();
      };
      ctrl.getConfig = function () {
        return config;
      };
      var startWatching = function startWatching() {
        $scope.$watch('viewport', function (view) {
          ctrl.refreshData();
        }, true);
        $scope.$watch('communeParams', function () {
          // TODO : rename to generic
          if ($scope.communeParams.temporalite !== "EVOLUTION" && $scope.communeParams.representation !== "RELATIF") {
            $scope.communeParams.unite = "VALEUR";
          }
          ctrl.refreshData();
        }, true);
      };
      ctrl.setHoveredCommune = function (commune) {
        hoveredCommune = commune;
      };
      ctrl.getHoveredCommune = function () {
        return hoveredCommune;
      };

      /**
       *
       * @param commune
       */
      ctrl.setReferenceCommune = function (commune) {
        ctrl.loadReference(commune.id).then(function () {
          // nothing ?
        });
      };
      ctrl.onSearchFieldSelection = function (entity) {
        if (config.publicObs) {
          ctrl.setReferenceCommune(entity);
        } else {
          ctrl.centerMapOn(entity);
        }
      };

      /**
       *
       */
      ctrl.centerMapOn = function (entity) {
        selectedId = entity.id;

        // pour les dom, on centre dessus
        if (entity.departement > 900) {
          mapManagerCtrl.setViewport({
            lat: entity.coordinates.lat,
            lng: entity.coordinates.lng,
            zoom: 6
          });
        } else {
          // pour la mertropole on centre au global sur la france métropolitaine
          mapManagerCtrl.setViewport({
            lat: 46.8,
            lng: 2.25,
            zoom: 6
          });
        }
        // necessaire pour que la selection soit toujour redessinée
        ctrl.refreshData();
      };
      ctrl.getSelectedId = function () {
        return selectedId;
      };
      ctrl.setSelectedId = function (entityId) {
        selectedId = entityId;
      };

      /**
       * Load reference from server, either from given code insee, or defaulting to geoloc if insee is null or invalid.
       */
      ctrl.loadReference = function (refIdToLoad, centerOnMap) {
        // set empty default if none
        if ($scope.reference == null) {
          $scope.reference = {
            id: null,
            name: "Pas de référence",
            coordinates: null
          };
        }
        // then load
        return $http.get(config.resourceBaseUrl + "/reference", {
          params: {
            year: $scope.communeParams.anneeInstantane,
            id: refIdToLoad
          }
        }).then(function (response) {
          var reference = response.data;
          referenceId = reference.id;
          $scope.reference = reference;
          if (reference.coordinates) {
            // ne pas recentrer évite de recharger les contours, a ne faire que si les contours sont déjà là, c'est à dire sur un click de contour
            if (centerOnMap !== false) {
              ctrl.centerMapOn(reference);
            }
          }
        });
      };

      /**
       *
       */
      ctrl.refreshData = $debounce(function () {
        if (requestCanceler) {
          requestCanceler.resolve();
        }
        requestCanceler = $q.defer();
        $scope.$broadcast("obs:data-load:start");
        var viewport = mapManagerCtrl.getViewport();
        var mapDataParams = _.extend({}, $scope.communeParams, {
          referenceId: referenceId,
          position: {
            lat: viewport.lat,
            lng: viewport.lng
          }
        });
        $http.post(config.resourceBaseUrl + "/map-data", mapDataParams, {
          timeout: requestCanceler.promise
        }).then(function (response) {
          var infoCommune = response.data;

          // TODO : clean this
          // Toujours la valeur absolue pour l'affichage de la valeur de référence
          var formatParameters = _.extend({}, $scope.communeParams, {
            representation: 'ABSOLU'
          });

          // quand on est en instantané, toujours en VALEUR pour les valeurs de ref.
          if ($scope.communeParams.temporalite === 'INSTANTANE') {
            formatParameters.unite = 'VALEUR';
          }
          $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
          $scope.referenceValue = obsUtils.formatValue(formatParameters, infoCommune.referenceValue);
          $scope.departementValue = obsUtils.formatValue(formatParameters, infoCommune.departementValue);
          $scope.departementCodeInsee = infoCommune.departementCodeInsee;
          $scope.strateValue = obsUtils.formatValue(formatParameters, infoCommune.strateValue);
          $scope.strate = obsUtils.getStrateLabel(infoCommune.strate);
          $scope.paysValue = obsUtils.formatValue(formatParameters, infoCommune.paysValue);
          // TODO : end

          $scope.$broadcast("obs:data-load:success", infoCommune);
        });
      }, 250);
      $scope.$on("$destroy", function () {
        // cancel the currently waiting debounced call, if it exists.
        ctrl.refreshData.cancel();
        if (requestCanceler != null) {
          requestCanceler.resolve();
        }
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementManager.js", __webpack_require__(1)))

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _, L) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementMap", ["leaflet", "leafletDefaultConfig", "leafletUtils", "ObsStratManager", "obsUtils", "directiveUtils", "$timeout", function (leaflet, leafletDefaultConfig, leafletUtils, ObsStratManager, obsUtils, directiveUtils, $timeout) {
  return {
    restrict: "A",
    scope: true,
    require: ["obsDepartementMap", "obsLeafletMap", "^obsDepartementManager"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapCtrl = controllers[1],
        mapManagerCtrl = controllers[2];
      mapCtrl.setUpdateHandler(ctrl.updateData);
      ctrl.initialize(mapCtrl, mapManagerCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        mapCtrl = null,
        managerCtrl = null;
      var geoManager = new ObsStratManager({}),
        geoConfig = geoManager.getConfig();
      ctrl.initialize = function (_mapCtrl, _managerCtrl) {
        mapCtrl = _mapCtrl;
        managerCtrl = _managerCtrl;

        // need to wait for the map to be here... didnt found a proper way, so we watch the same condition once.
        var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
          if (mapConfig != null) {
            unwatch();
            $timeout(addSearchFieldControl, 1);
          }
        });
      };
      var legend, searchControl, shortcuts, contextInfo, tooltipElement, selectedLayer;
      ctrl.updateData = function (infoCommune) {
        mapCtrl.getMap().then(function (map) {
          if (shortcuts == null) {
            shortcuts = leafletUtils.addShortcuts($scope, $element, leaflet, map);
          }

          // initialize contextInfo
          if (contextInfo == null) {
            addContextInfoControl(map);
          }
          if (tooltipElement == null) {
            createTooltipElement();
          }

          // refresh manager
          geoManager.setStrates(infoCommune.strates);

          // create legend
          if (legend != null) {
            legend.remove();
          }
          legend = geoManager.generateLegend();
          map.addControl(legend);

          // creates geojson layout

          generateGeoJson(map, infoCommune);
        });
      };
      var addContextInfoControl = function addContextInfoControl(map) {
        var linkFn = directiveUtils.compileDirective("obsDepartementMapContextInfo");
        var contentEl = null;
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          contentEl = clone;
        });
        contextInfo = leaflet.control({
          position: "bottomleft"
        });
        contextInfo.onAdd = function () {
          return contentEl[0];
        };
        contextInfo.addTo(map);
      };
      var createTooltipElement = function createTooltipElement() {
        var linkFn = directiveUtils.compileDirective("obsDepartementMapTooltip");
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          tooltipElement = clone[0];
        });
      };
      var addSearchFieldControl = function addSearchFieldControl() {
        mapCtrl.getMap().then(function (map) {
          searchControl = leaflet.control({
            position: "topleft"
          });
          searchControl.onAdd = function () {
            var searchWrapper = $("<div>").addClass("leaflet-control-search-field");
            var searchFieldLink = directiveUtils.compileDirective("obsDepartementSearchField");
            var searchField;
            searchFieldLink($scope, function (_searchField) {
              searchField = _searchField;
              searchField.appendTo($element);
            });
            searchField.appendTo(searchWrapper);
            // avoid scrolling map when in widget
            _.each(["mousedown", "mouseup", "mousewheel"], function (eventName) {
              searchWrapper.bind(eventName, function (e) {
                e.stopPropagation();
              });
            });
            return searchWrapper[0];
          };
          searchControl.addTo(map);
        });
      };
      var generateGeoJson = function generateGeoJson(map, infoMapCommune) {
        var getSelectedId = function getSelectedId() {
          return managerCtrl.getSelectedId();
        };

        // Afficher les nom et données sur la carte directement
        if ($scope.labels) {
          var _iterator = _createForOfIteratorHelper($scope.labels),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var label = _step.value;
              map.removeLayer(label);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        $scope.labels = [];
        _.extend($scope, {
          geojson: {
            data: infoMapCommune.features,
            onEachFeature: function onEachFeature(feature, layer) {
              var featureId = feature.properties.id;
              var style = geoManager.getGeoStyle(feature);
              if (featureId === getSelectedId()) {
                selectedLayer = layer;
                _.extend(style, geoConfig.selectedStyle);
              }
              if ($scope.reference != null && featureId === $scope.reference.id) {
                _.extend(style, geoConfig.referenceStyle);
              }
              layer.setStyle(style);
              layer.bindTooltip(tooltipElement, {
                sticky: true,
                direction: 'right',
                offset: [20, 0]
              });

              // Afficher les nom et données sur la carte directement
              // ajout de labels

              if ($scope.communeParams.label && map.getZoom() > 6) {
                var value = feature.properties.value;
                value = obsUtils.formatValue($scope.communeParams, value);
                var label = L.marker(layer.getBounds().getCenter(), {
                  icon: L.divIcon({
                    className: 'label-layer-carto',
                    html: '<div class="detail-carto"><div>' + feature.properties.nom + '</div><div>' + value + '</div></div>',
                    iconSize: [100, 40]
                  })
                }).addTo(map);
                $scope.labels.push(label);
              }
              layer.on("click", function (e) {
                // uniquement pour le public : changement de référence sur le click
                if (managerCtrl.getConfig().publicObs) {
                  selectArea(featureId, layer);
                  // sur le public, on ne recentre pas sur la référence suite au click pour ne pas déclencher de rechargement des contours
                  managerCtrl.loadReference(featureId, false);
                  managerCtrl.refreshData(); // La valeur pour la référence doit être mise à jour (TAEL-1163)
                } else if (featureId === getSelectedId()) {
                  managerCtrl.setSelectedId(null);
                  selectedLayer = null;
                  layer.setStyle(geoConfig.defaultStyle);
                } else {
                  selectArea(featureId, layer);
                }
              });
              layer.on("mouseover", function (e) {
                managerCtrl.setHoveredCommune(feature.properties);
                layer.setStyle(geoConfig.hoverStyle);
              });
              layer.on("mouseout", function (e) {
                managerCtrl.setHoveredCommune(null);
                if ($scope.reference != null && featureId === $scope.reference.id) {
                  layer.setStyle(geoConfig.referenceStyle);
                } else if (featureId === getSelectedId()) {
                  layer.setStyle(geoConfig.selectedStyle);
                } else {
                  layer.setStyle(geoConfig.defaultStyle);
                }
              });
            }
          }
        });
        var selectArea = function selectArea(featureId, layer) {
          if (selectedLayer) {
            selectedLayer.setStyle(geoConfig.defaultStyle);
          }
          managerCtrl.setSelectedId(featureId);
          selectedLayer = layer;
          layer.setStyle(geoConfig.selectedStyle);
        };
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementMap.js", __webpack_require__(4), __webpack_require__(1), __webpack_require__(20)))

/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementMapContextInfo", function () {
  return {
    restrict: "E",
    require: "^obsDepartementManager",
    scope: true,
    replace: true,
    template: __webpack_require__(886)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementMapContextInfo.js"))

/***/ }),

/***/ 864:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementMapTooltip", ["obsUtils", function (obsUtils) {
  return {
    restrict: "E",
    require: "^obsDepartementManager",
    scope: true,
    replace: true,
    template: "\n        <div class=\"leaflet-control control obs-map-tooltip\">\n            <div class=\"hovered-name\">{{hoverName}}</div>\n            <div class=\"hovered-value\">\n                {{referenceLabel}}: {{hoverValue}}\n            </div>\n        </div>",
    link: function link($scope, $el, $attrs, managerCtrl) {
      $scope.$watch(function () {
        return managerCtrl.getHoveredCommune();
      }, function (hoveredCommune) {
        if (hoveredCommune == null) {
          $scope.hoverName = null;
          $scope.hoverValue = null;
        } else {
          $scope.hoverName = hoveredCommune.nom;
          $scope.hoverValue = obsUtils.formatValue($scope.communeParams, hoveredCommune.value);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementMapTooltip.js"))

/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementPanel", ["applicationSettings", "$translate", "$http", "obsPanelService", "obsUtils", function (applicationSettings, $translate, $http, obsPanelService, obsUtils) {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(887),
    link: function link($scope, $el, $attrs) {
      $scope.optionsCollapsed = false;
      $scope.filtresCollapsed = true;
      $scope.datatypes = [{
        name: $translate('observatoire.datatype.Dette'),
        value: 'ENCOURS_DETTE'
      }, {
        name: $translate('observatoire.datatype.Annuite'),
        value: 'ANNUITE_DETTE'
      }, {
        name: $translate('observatoire.datatype.Amortissement'),
        value: 'AMORTISSEMENT_DETTE'
      }, {
        name: $translate('observatoire.datatype.Interet'),
        value: 'INTERET_DETTE'
      }, {
        name: $translate('observatoire.datatype.Dotations'),
        value: 'DOTATION_GLOBALE_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.RecetteDeFonctionnement'),
        value: 'RECETTES_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.DetteSurRecetteDeFonctionnement'),
        value: 'DETTE_SUR_RECETTES_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.PopulationDGFIP'),
        value: 'POPULATION_DGFIP'
      }, {
        name: $translate('observatoire.datatype.POPULATION_DGCL_DGF'),
        value: 'POPULATION_DGCL_DGF'
      }
      //  {name: $translate('observatoire.datatype.POPULATION_INSEE'), value: 'POPULATION_INSEE'}
      ];
      $scope.isParHab = function (datatype) {
        return !(datatype === 'POPULATION_DGCL_DGF' || datatype === 'POPULATION_INSEE' || datatype === 'POPULATION_DGFIP' || datatype === 'DETTE_SUR_POTENTIEL_FINANCIER' || datatype === 'DETTE_SUR_RECETTES_FONCTIONNEMENT');
      };
      $scope.sourcesPopulation = [{
        name: 'DGFiP',
        value: 'DGFIP'
      }, {
        name: 'DGF',
        value: 'DGCL_DGF'
      }
      // {name: 'INSEE', value: 'INSEE'},
      ];
      $scope.zonages = [{
        name: $translate('observatoire.zonage.France'),
        value: 'FRANCE'
      }];
      if (!$scope.observatoryConfig.publicObs) {
        $scope.zonages.push({
          name: $translate('observatoire.zonage.Panel'),
          value: 'PANEL'
        });
        obsPanelService.getPanels().then(function (panels) {
          $scope.panels = panels;
          if ($scope.panels.length > 0) {
            $scope.communeParams.panelId = $scope.panels[0].id;
          }
        });
      }
      $scope.representations = [{
        name: $translate('observatoire.representation.Absolu'),
        value: 'ABSOLU'
      }, {
        name: $translate('observatoire.representation.RelatifCommune'),
        value: 'RELATIF'
      }];
      $scope.unites = [{
        name: $translate('observatoire.unite.EnValeur'),
        value: 'VALEUR'
      }, {
        name: $translate('observatoire.unite.EnPourcentage'),
        value: 'POURCENTAGE'
      }];
      $scope.temporalites = [{
        name: $translate('observatoire.temporalite.Instantané'),
        value: 'INSTANTANE'
      }, {
        name: $translate('observatoire.temporalite.Evolution'),
        value: 'EVOLUTION'
      }];
      $scope.anneesDefaut = obsUtils.getAnneesDispo('departement');
      $scope.annees = $scope.anneesDefaut;
      $scope.$watch('communeParams', function () {
        $scope.annees = $scope.anneesDefaut;
        if (!$scope.communeParams.anneeInstantane) {
          $scope.communeParams.anneeInstantane = obsUtils.getDerniereAnneeDispo();
        }
        if (!$scope.communeParams.anneeDebut) {
          $scope.communeParams.anneeDebut = obsUtils.getDerniereAnneeDispo() - 1;
        }
        if (!$scope.communeParams.anneeFin) {
          $scope.communeParams.anneeFin = obsUtils.getDerniereAnneeDispo();
        }
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementPanel.js"))

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsDepartementSearchField", function () {
  return {
    restrict: "E",
    require: "^obsDepartementManager",
    replace: true,
    template: '' + '<div class="obs-search-field">' + '   <tl-search-field config="searchConfig"></tl-search-field>' + '</div>',
    link: function link($scope, $el, $attrs, mapManagerCtrl) {
      var obsConfig = $scope.observatoryConfig,
        searchUrl = obsConfig.resourceBaseUrl + "/search";
      $scope.searchExtraParams = {
        actuelsSeulement: true
      };
      $scope.searchConfig = {
        labelAttribute: "nom",
        extraParams: "searchExtraParams",
        searchUrl: searchUrl,
        resultTemplate: "" + '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' + '<span class="dept">{{result.departement}}</span>',
        onSelect: function onSelect(commune) {
          mapManagerCtrl.onSearchFieldSelection(commune);
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/departement/obsDepartementSearchField.js"))

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsEpciSearchField", function () {
  return {
    restrict: "E",
    require: "^obsEpciManager",
    replace: true,
    template: '' + '<div class="obs-search-field">' + '   <tl-search-field config="searchConfig"></tl-search-field>' + '</div>',
    link: function link($scope, $el, $attrs, mapManagerCtrl) {
      $scope.searchExtraParams = {
        actuelsSeulement: true
      };
      $scope.searchConfig = {
        labelAttribute: "nom",
        extraParams: "searchExtraParams",
        searchUrl: "/rest/observatoire/epci/search",
        resultTemplate: "" + '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' + '<span class="dept">{{result.departement}}</span>',
        onSelect: function onSelect(epci) {
          mapManagerCtrl.centerMapOn(epci);
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEcpiSearchField.js"))

/***/ }),

/***/ 868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsEpciManager", ["$q", "$http", "$debounce", "obsUtils", function ($q, $http, $debounce, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ["obsEpciManager", "obsMapManager"],
    controllerAs: "mapManagerCtrl",
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapManagerCtrl = controllers[1],
        obsConfig = $scope.observatoryConfig;
      ctrl.initialize(obsConfig, mapManagerCtrl);
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        config = null,
        mapManagerCtrl = null,
        requestCanceler = null,
        selectedId = null,
        referenceId = null,
        hoveredEpci = null;
      ctrl.initialize = function (_config, _mapManagerCtrl) {
        config = _config;
        mapManagerCtrl = _mapManagerCtrl;
        ctrl.loadReference();
        mapManagerCtrl.setViewport({
          lat: 46.8,
          lng: 2.25,
          zoom: 6
        });
        startWatching();
      };
      ctrl.getConfig = function () {
        return config;
      };
      var startWatching = function startWatching() {
        $scope.$watch('viewport', function (view) {
          ctrl.refreshData();
        }, true);
        $scope.$watch('epciParams', function () {
          // TODO : rename to generic
          if ($scope.epciParams.temporalite !== "EVOLUTION" && $scope.epciParams.representation !== "RELATIF") {
            $scope.epciParams.unite = "VALEUR";
          }
          ctrl.refreshData();
        }, true);
      };
      ctrl.setHoveredEpci = function (epci) {
        hoveredEpci = epci;
      };
      ctrl.getHoveredEpci = function () {
        return hoveredEpci;
      };

      /**
       *
       * @param commune
       */
      ctrl.setReferenceEpci = function (epci) {
        ctrl.loadReference(epci.id).then(function () {
          // nothing ?
        });
      };

      /**
       *
       */
      ctrl.centerMapOn = function (entity) {
        selectedId = entity.id;
        mapManagerCtrl.setViewport({
          lat: entity.coordinates.lat,
          lng: entity.coordinates.lng,
          zoom: 10
        });
      };
      ctrl.getSelectedId = function () {
        return selectedId;
      };
      ctrl.setSelectedId = function (entityId) {
        selectedId = entityId;
      };
      ctrl.onSearchFieldSelection = function (entity) {
        if (config.publicObs) {
          ctrl.setReferenceEpci(entity);
        } else {
          ctrl.centerMapOn(entity);
        }
      };
      ctrl.centerMapOn = function (entity) {
        selectedId = entity.id;
        mapManagerCtrl.setViewport({
          lat: entity.coordinates.lat,
          lng: entity.coordinates.lng,
          zoom: 10
        });
      };

      /**
       *
       */
      ctrl.loadReference = function (refIdToLoad, centerOnMap) {
        console.log('refIdToLoad', refIdToLoad);
        if ($scope.reference == null) {
          // set empty default
          $scope.reference = {
            id: null,
            name: "Pas de référence",
            coordinates: null
          };
        }
        // then load
        return $http.get(config.referenceUrl, {
          params: {
            year: $scope.epciParams.anneeInstantane,
            id: refIdToLoad
          }
        }).then(function (response) {
          var reference = response.data;
          referenceId = reference.id;
          $scope.reference = reference;
          if (reference.coordinates) {
            if (centerOnMap !== false) {
              ctrl.centerMapOn(reference);
            }
          }
        });
      };

      /**
       *
       */
      ctrl.refreshData = $debounce(function () {
        if (requestCanceler) {
          requestCanceler.resolve();
        }
        requestCanceler = $q.defer();
        $scope.$broadcast("obs:data-load:start");
        var viewport = mapManagerCtrl.getViewport();
        var mapDataParams = _.extend({}, $scope.epciParams, {
          referenceId: referenceId,
          position: {
            lat: viewport.lat,
            lng: viewport.lng
          }
        });
        $http.post(config.dataUrl, mapDataParams, {
          timeout: requestCanceler.promise
        }).then(function (response) {
          var infoEcpi = response.data;

          // TODO : clean this
          // Toujours la valeur absolue pour l'affichage de la valeur de référence
          var formatParameters = _.extend({}, $scope.epciParams, {
            representation: 'ABSOLU',
            unite: 'VALEUR'
          });
          $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
          $scope.referenceValue = obsUtils.formatValue(formatParameters, infoEcpi.referenceValue);
          // TODO : end
          $scope.$broadcast("obs:data-load:success", infoEcpi);
        });
      }, 250);
      $scope.$on("$destroy", function () {
        // cancel the currently waiting debounced call, if it exists.
        ctrl.refreshData.cancel();
        if (requestCanceler != null) {
          requestCanceler.resolve();
        }
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEpciManager.js", __webpack_require__(1)))

/***/ }),

/***/ 869:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _, L) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

/**
 * creation des éléments visuels au dessus de la carte (l"gende, search, ...)
 * gestion des interactions souris (click, ...)
 */
ngModule.directive("obsEpciMap", ["$q", "$timeout", "leaflet", "directiveUtils", "leafletDefaultConfig", "leafletUtils", "ObsStratManager", "obsUtils", function ($q, $timeout, leaflet, directiveUtils, leafletDefaultConfig, leafletUtils, ObsStratManager, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ["obsEpciMap", "obsLeafletMap", "^obsEpciManager"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapCtrl = controllers[1],
        mapManagerCtrl = controllers[2];
      mapCtrl.setUpdateHandler(ctrl.updateData);
      ctrl.initialize(mapCtrl, mapManagerCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        mapCtrl = null,
        managerCtrl = null;
      var geoManager = new ObsStratManager({}),
        geoConfig = geoManager.getConfig();
      ctrl.initialize = function (_mapCtrl, _managerCtrl) {
        mapCtrl = _mapCtrl;
        managerCtrl = _managerCtrl;

        // need to wait for the map to be here... didnt found a proper way, so we watch the same condition once.
        var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
          if (mapConfig != null) {
            unwatch();
            $timeout(addSearchFieldControl, 1);
          }
        });
      };
      var legend, searchControl, shortcuts, contextInfo, tooltipElement, selectedLayer;
      ctrl.updateData = function (infoEpci) {
        mapCtrl.getMap().then(function (map) {
          if (shortcuts == null) {
            shortcuts = leafletUtils.addShortcuts($scope, $element, leaflet, map);
          }

          // initialize contextInfo
          if (contextInfo == null) {
            addContextInfoControl(map);
          }
          if (tooltipElement == null) {
            createTooltipElement();
          }

          // refresh manager
          geoManager.setStrates(infoEpci.strates);

          // create legend
          if (legend) {
            legend.remove();
          }
          legend = geoManager.generateLegend();
          map.addControl(legend);

          // creates geojson layout
          generateGeoJson(map, infoEpci);
        });
      };
      var addContextInfoControl = function addContextInfoControl(map) {
        var contextInfoDirectiveName = "obsEpciMapContextInfo";
        if (managerCtrl.getConfig().contextInfoDirective) {
          contextInfoDirectiveName = managerCtrl.getConfig().contextInfoDirective;
        }
        var linkFn = directiveUtils.compileDirective(contextInfoDirectiveName);
        var contentEl = null;
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          contentEl = clone;
        });
        contextInfo = leaflet.control({
          position: "bottomleft"
        });
        contextInfo.onAdd = function () {
          return contentEl[0];
        };
        contextInfo.addTo(map);
      };
      var createTooltipElement = function createTooltipElement() {
        var linkFn = directiveUtils.compileDirective("obsEpciMapTooltip");
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          tooltipElement = clone[0];
        });
      };
      var addSearchFieldControl = function addSearchFieldControl() {
        mapCtrl.getMap().then(function (map) {
          searchControl = leaflet.control({
            position: "topleft"
          });
          searchControl.onAdd = function () {
            var searchWrapper = $("<div>").addClass("leaflet-control-search-field");
            var searchFieldLink = directiveUtils.compileDirective("obsEpciSearchField");
            var searchField;
            searchFieldLink($scope, function (_searchField) {
              searchField = _searchField;
              searchField.appendTo($element);
            });
            searchField.appendTo(searchWrapper);
            // avoid scrolling map when in widget
            _.each(["mousedown", "mouseup", "mousewheel"], function (eventName) {
              searchWrapper.bind(eventName, function (e) {
                e.stopPropagation();
              });
            });
            return searchWrapper[0];
          };
          searchControl.addTo(map);
        });
      };
      var generateGeoJson = function generateGeoJson(map, infoMapEpci) {
        // Afficher les nom et données sur la carte directement
        if ($scope.labels) {
          var _iterator = _createForOfIteratorHelper($scope.labels),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var label = _step.value;
              map.removeLayer(label);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        $scope.labels = [];
        var getSelectedId = function getSelectedId() {
          return managerCtrl.getSelectedId();
        };
        _.extend($scope, {
          geojson: {
            data: infoMapEpci.features,
            onEachFeature: function onEachFeature(feature, layer) {
              var featureId = feature.properties.id;
              var style = geoManager.getGeoStyle(feature);
              if (featureId === getSelectedId()) {
                selectedLayer = layer;
                _.extend(style, geoConfig.selectedStyle);
              }
              if ($scope.reference != null && featureId === $scope.reference.id) {
                _.extend(style, geoConfig.referenceStyle);
              }
              layer.setStyle(style);
              layer.bindTooltip(tooltipElement, {
                sticky: true,
                direction: 'right',
                offset: [20, 0]
              });

              // Afficher les nom et données sur la carte directement
              // ajout de labels

              if ($scope.epciParams.label && map.getZoom() > 8) {
                var value = feature.properties.value;
                value = obsUtils.formatValue($scope.epciParams, value);
                var label = L.marker(layer.getBounds().getCenter(), {
                  icon: L.divIcon({
                    className: 'label-layer-carto',
                    html: '<div class="detail-carto"><div>' + feature.properties.nom + '</div><div>' + value + '</div></div>',
                    iconSize: [100, 40]
                  })
                }).addTo(map);
                $scope.labels.push(label);
              }
              layer.on("click", function (e) {
                // uniquement pour le public : changement de référence sur le click (egalement sur sytale+)
                if (managerCtrl.getConfig().publicObs) {
                  selectArea(featureId, layer);
                  // sur le public, on ne recentre pas sur la référence suite au click pour ne pas déclencher de rechargement des contours
                  managerCtrl.loadReference(featureId, false);
                  managerCtrl.refreshData(); // La valeur pour la référence doit être mise à jour (TAEL-1163)
                } else if (featureId === getSelectedId()) {
                  managerCtrl.setSelectedId(null);
                  selectedLayer = null;
                  layer.setStyle(geoConfig.defaultStyle);
                } else {
                  selectArea(featureId, layer);
                }
              });
              layer.on("mouseover", function (e) {
                managerCtrl.setHoveredEpci(feature.properties);
                layer.setStyle(geoConfig.hoverStyle);
              });
              layer.on("mouseout", function (e) {
                managerCtrl.setHoveredEpci(null);
                if ($scope.reference != null && featureId === $scope.reference.id) {
                  layer.setStyle(geoConfig.referenceStyle);
                } else if (featureId === getSelectedId()) {
                  layer.setStyle(geoConfig.selectedStyle);
                } else {
                  layer.setStyle(geoConfig.defaultStyle);
                }
              });
            }
          }
        });
        var selectArea = function selectArea(featureId, layer) {
          if (selectedLayer) {
            selectedLayer.setStyle(geoConfig.defaultStyle);
          }
          managerCtrl.setSelectedId(featureId);
          selectedLayer = layer;
          layer.setStyle(geoConfig.selectedStyle);
        };
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEpciMap.js", __webpack_require__(4), __webpack_require__(1), __webpack_require__(20)))

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsEpciMapContextInfo", function () {
  return {
    restrict: "E",
    require: "^obsEpciManager",
    scope: true,
    replace: true,
    template: __webpack_require__(888)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEpciMapContextInfo.js"))

/***/ }),

/***/ 871:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsEpciMapTooltip", ["obsUtils", function (obsUtils) {
  return {
    restrict: "E",
    require: "^obsEpciManager",
    scope: true,
    replace: true,
    template: "\n        <div class=\"leaflet-control control obs-map-tooltip\">\n            <div class=\"hovered-name\">{{hoverName}}</div>\n            <div class=\"hovered-value\">\n                {{referenceLabel}}: {{hoverValue}}\n            </div>\n        </div>",
    link: function link($scope, $el, $attrs, managerCtrl) {
      $scope.$watch(function () {
        return managerCtrl.getHoveredEpci();
      }, function (epci) {
        if (epci == null) {
          $scope.hoverName = null;
          $scope.hoverValue = null;
        } else {
          $scope.hoverName = epci.nom;
          $scope.hoverValue = obsUtils.formatValue($scope.epciParams, epci.value);
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEpciMapTooltip.js"))

/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsEpciPanel", ["$translate", "obsPanelService", "obsUtils", function ($translate, obsPanelService, obsUtils) {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(889),
    link: function link($scope, $el, $attrs) {
      $scope.optionsCollapsed = false;
      $scope.filtresCollapsed = true;
      $scope.datatypes = [{
        name: $translate('observatoire.datatype.Dette'),
        value: 'ENCOURS_DETTE'
      }, {
        name: $translate('observatoire.datatype.Annuite'),
        value: 'ANNUITE_DETTE'
      }, {
        name: $translate('observatoire.datatype.Amortissement'),
        value: 'AMORTISSEMENT_DETTE'
      }, {
        name: $translate('observatoire.datatype.Interet'),
        value: 'INTERET_DETTE'
      }, {
        name: $translate('observatoire.datatype.Dotations'),
        value: 'DOTATION_GLOBALE_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.RecetteDeFonctionnement'),
        value: 'RECETTES_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.DetteSurRecetteDeFonctionnement'),
        value: 'DETTE_SUR_RECETTES_FONCTIONNEMENT'
      }, {
        name: $translate('observatoire.datatype.PopulationDGFIP'),
        value: 'POPULATION_DGFIP'
      }, {
        name: $translate('observatoire.datatype.POPULATION_DGCL_DGF'),
        value: 'POPULATION_DGCL_DGF'
      }
      //{name: $translate('observatoire.datatype.POPULATION_INSEE'), value: 'POPULATION_INSEE'}
      ];
      $scope.sourcesPopulation = [{
        name: 'DGFiP',
        value: 'DGFIP'
      }, {
        name: 'DGF',
        value: 'DGCL_DGF'
      }
      //{name: 'INSEE', value: 'INSEE'},
      ];
      $scope.zonages = [{
        name: $translate('observatoire.zonage.Departement'),
        value: 'DEPARTEMENT'
      }, {
        name: $translate('observatoire.zonage.Voisinage'),
        value: 'VOISINAGE'
      }];
      if (!$scope.observatoryConfig.publicObs) {
        $scope.zonages.push({
          name: $translate('observatoire.zonage.Panel'),
          value: 'PANEL'
        });
        obsPanelService.getPanels().then(function (panels) {
          $scope.panels = panels;
          if ($scope.panels.length > 0) {
            $scope.epciParams.panelId = $scope.panels[0].id;
          }
        });
      }
      $scope.representations = [{
        name: $translate('observatoire.representation.Absolu'),
        value: 'ABSOLU'
      }, {
        name: $translate('observatoire.representation.RelatifEPCI'),
        value: 'RELATIF'
      }];
      $scope.unites = [{
        name: $translate('observatoire.unite.EnValeur'),
        value: 'VALEUR'
      }, {
        name: $translate('observatoire.unite.EnPourcentage'),
        value: 'POURCENTAGE'
      }];
      $scope.temporalites = [{
        name: $translate('observatoire.temporalite.Instantané'),
        value: 'INSTANTANE'
      }, {
        name: $translate('observatoire.temporalite.Evolution'),
        value: 'EVOLUTION'
      }];
      $scope.anneesDefaut = obsUtils.getAnneesDispo();
      $scope.annees = $scope.anneesDefaut;
      $scope.isParHab = function (datatype) {
        return !(datatype === 'POPULATION_DGCL_DGF' || datatype === 'POPULATION_INSEE' || datatype === 'POPULATION_DGFIP' || datatype === 'DETTE_SUR_POTENTIEL_FINANCIER' || datatype === 'DETTE_SUR_RECETTES_FONCTIONNEMENT');
      };
      $scope.$watch('epciParams', function () {
        $scope.annees = $scope.anneesDefaut;
        if (!$scope.epciParams.anneeInstantane) {
          $scope.epciParams.anneeInstantane = obsUtils.getDerniereAnneeDispo();
        }
        if (!$scope.epciParams.anneeDebut) {
          $scope.epciParams.anneeDebut = obsUtils.getDerniereAnneeDispo() - 1;
        }
        if (!$scope.epciParams.anneeFin) {
          $scope.epciParams.anneeFin = obsUtils.getDerniereAnneeDispo();
        }
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/epci/obsEpciPanel.js"))

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisManager", ["$q", "$http", "$debounce", "obsUtils", function ($q, $http, $debounce, obsUtils) {
  return {
    restrict: "A",
    scope: true,
    require: ['obsSdisManager', 'obsMapManager'],
    controllerAs: "sdisManagerCtrl",
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapManagerCtrl = controllers[1],
        obsConfig = $scope.observatoryConfig;
      ctrl.initialize(obsConfig, mapManagerCtrl);
    },
    controller: ["$scope", function controller($scope) {
      var ctrl = this,
        config = null,
        mapManagerCtrl = null,
        requestCanceler = null,
        selectedId = null,
        referenceId = null,
        hoveredCommune = null;
      ctrl.initialize = function (_config, _mapManagerCtrl) {
        config = _config;
        mapManagerCtrl = _mapManagerCtrl;
        ctrl.loadReference();
        mapManagerCtrl.setViewport({
          lat: 46.8,
          lng: 2.25,
          zoom: 6
        });
        startWatching();
      };
      ctrl.getConfig = function () {
        return config;
      };
      var startWatching = function startWatching() {
        $scope.$watch('viewport', function (view) {
          ctrl.refreshData();
        }, true);
        $scope.$watch('communeParams', function () {
          // TODO : rename to generic
          if ($scope.communeParams.temporalite !== "EVOLUTION" && $scope.communeParams.representation !== "RELATIF") {
            $scope.communeParams.unite = "VALEUR";
          }
          ctrl.refreshData();
        }, true);
      };
      ctrl.setHoveredCommune = function (commune) {
        hoveredCommune = commune;
      };
      ctrl.getHoveredCommune = function () {
        return hoveredCommune;
      };

      /**
       *
       * @param commune
       */
      ctrl.setReferenceCommune = function (commune) {
        ctrl.loadReference(commune.id).then(function () {
          // nothing ?
        });
      };
      ctrl.onSearchFieldSelection = function (entity) {
        if (config.publicObs) {
          ctrl.setReferenceCommune(entity);
        } else {
          ctrl.centerMapOn(entity);
        }
      };

      /**
       *
       */
      ctrl.centerMapOn = function (entity) {
        selectedId = entity.id;

        // pour les dom, on centre dessus
        if (entity.departement > 900) {
          mapManagerCtrl.setViewport({
            lat: entity.coordinates.lat,
            lng: entity.coordinates.lng,
            zoom: 6
          });
        } else {
          // pour la mertropole on centre au global sur la france métropolitaine
          mapManagerCtrl.setViewport({
            lat: 46.8,
            lng: 2.25,
            zoom: 6
          });
        }
        // necessaire pour que la selection soit toujour redessinée
        ctrl.refreshData();
      };
      ctrl.getSelectedId = function () {
        return selectedId;
      };
      ctrl.setSelectedId = function (entityId) {
        selectedId = entityId;
      };

      /**
       * Load reference from server, either from given code insee, or defaulting to geoloc if insee is null or invalid.
       */
      ctrl.loadReference = function (refIdToLoad, centerOnMap) {
        // set empty default if none
        if ($scope.reference == null) {
          $scope.reference = {
            id: null,
            name: "Pas de référence",
            coordinates: null
          };
        }
        // then load
        return $http.get(config.resourceBaseUrl + "/reference", {
          params: {
            year: $scope.communeParams.anneeInstantane,
            id: refIdToLoad
          }
        }).then(function (response) {
          var reference = response.data;
          referenceId = reference.id;
          $scope.reference = reference;
          if (reference.coordinates) {
            // ne pas recentrer évite de recharger les contours, a ne faire que si les contours sont déjà là, c'est à dire sur un click de contour
            if (centerOnMap !== false) {
              ctrl.centerMapOn(reference);
            }
          }
        });
      };

      /**
       *
       */
      ctrl.refreshData = $debounce(function () {
        if (requestCanceler) {
          requestCanceler.resolve();
        }
        requestCanceler = $q.defer();
        $scope.$broadcast("obs:data-load:start");
        var viewport = mapManagerCtrl.getViewport();
        var mapDataParams = _.extend({}, $scope.communeParams, {
          referenceId: referenceId,
          position: {
            lat: viewport.lat,
            lng: viewport.lng
          }
        });
        $http.post(config.resourceBaseUrl + "/map-data", mapDataParams, {
          timeout: requestCanceler.promise
        }).then(function (response) {
          var infoCommune = response.data;

          // TODO : clean this
          // Toujours la valeur absolue pour l'affichage de la valeur de référence
          var formatParameters = _.extend({}, $scope.communeParams, {
            representation: 'ABSOLU'
          });

          // quand on est en instantané, toujours en VALEUR pour les valeurs de ref.
          if ($scope.communeParams.temporalite === 'INSTANTANE') {
            formatParameters.unite = 'VALEUR';
          }
          $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
          $scope.referenceValue = obsUtils.formatValue(formatParameters, infoCommune.referenceValue);
          $scope.departementValue = obsUtils.formatValue(formatParameters, infoCommune.departementValue);
          $scope.departementCodeInsee = infoCommune.departementCodeInsee;
          $scope.categorie = infoCommune.categorie;
          console.log(infoCommune, $scope.categorie);
          $scope.strateValue = obsUtils.formatValue(formatParameters, infoCommune.strateValue);
          $scope.strate = obsUtils.getStrateLabel(infoCommune.strate);
          $scope.paysValue = obsUtils.formatValue(formatParameters, infoCommune.paysValue);
          // TODO : end

          $scope.$broadcast("obs:data-load:success", infoCommune);
        });
      }, 250);
      $scope.$on("$destroy", function () {
        // cancel the currently waiting debounced call, if it exists.
        ctrl.refreshData.cancel();
        if (requestCanceler != null) {
          requestCanceler.resolve();
        }
      });
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisManager.js", __webpack_require__(1)))

/***/ }),

/***/ 874:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, _, L) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);


function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisMap", ["leaflet", "leafletDefaultConfig", "leafletUtils", "ObsStratManager", "obsUtils", "directiveUtils", "$timeout", function (leaflet, leafletDefaultConfig, leafletUtils, ObsStratManager, obsUtils, directiveUtils, $timeout) {
  return {
    restrict: "A",
    scope: true,
    require: ["obsSdisMap", "obsLeafletMap", "^obsSdisManager"],
    link: function link($scope, $el, $attrs, controllers) {
      var ctrl = controllers[0],
        mapCtrl = controllers[1],
        mapManagerCtrl = controllers[2];
      mapCtrl.setUpdateHandler(ctrl.updateData);
      ctrl.initialize(mapCtrl, mapManagerCtrl);
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      var ctrl = this,
        mapCtrl = null,
        managerCtrl = null;
      var geoManager = new ObsStratManager({}),
        geoConfig = geoManager.getConfig();
      ctrl.initialize = function (_mapCtrl, _managerCtrl) {
        mapCtrl = _mapCtrl;
        managerCtrl = _managerCtrl;

        // need to wait for the map to be here... didnt found a proper way, so we watch the same condition once.
        var unwatch = $scope.$watch("mapConfig", function (mapConfig) {
          if (mapConfig != null) {
            unwatch();
            $timeout(addSearchFieldControl, 1);
          }
        });
      };
      var legend, searchControl, shortcuts, contextInfo, tooltipElement, selectedLayer;
      ctrl.updateData = function (infoCommune) {
        mapCtrl.getMap().then(function (map) {
          if (shortcuts == null) {
            shortcuts = leafletUtils.addShortcuts($scope, $element, leaflet, map);
          }

          // initialize contextInfo
          if (contextInfo == null) {
            addContextInfoControl(map);
          }
          if (tooltipElement == null) {
            createTooltipElement();
          }

          // refresh manager
          geoManager.setStrates(infoCommune.strates);

          // create legend
          if (legend != null) {
            legend.remove();
          }
          legend = geoManager.generateLegend();
          map.addControl(legend);

          // creates geojson layout

          generateGeoJson(map, infoCommune);
        });
      };
      var addContextInfoControl = function addContextInfoControl(map) {
        var linkFn = directiveUtils.compileDirective("obsSdisMapContextInfo");
        var contentEl = null;
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          contentEl = clone;
        });
        contextInfo = leaflet.control({
          position: "bottomleft"
        });
        contextInfo.onAdd = function () {
          return contentEl[0];
        };
        contextInfo.addTo(map);
      };
      var createTooltipElement = function createTooltipElement() {
        var linkFn = directiveUtils.compileDirective("obsSdisMapTooltip");
        linkFn($scope, function (clone) {
          clone.appendTo($element);
          tooltipElement = clone[0];
        });
      };
      var addSearchFieldControl = function addSearchFieldControl() {
        mapCtrl.getMap().then(function (map) {
          searchControl = leaflet.control({
            position: "topleft"
          });
          searchControl.onAdd = function () {
            var searchWrapper = $("<div>").addClass("leaflet-control-search-field");
            var searchFieldLink = directiveUtils.compileDirective("obsSdisSearchField");
            var searchField;
            searchFieldLink($scope, function (_searchField) {
              searchField = _searchField;
              searchField.appendTo($element);
            });
            searchField.appendTo(searchWrapper);
            // avoid scrolling map when in widget
            _.each(["mousedown", "mouseup", "mousewheel"], function (eventName) {
              searchWrapper.bind(eventName, function (e) {
                e.stopPropagation();
              });
            });
            return searchWrapper[0];
          };
          searchControl.addTo(map);
        });
      };
      var generateGeoJson = function generateGeoJson(map, infoMapCommune) {
        var getSelectedId = function getSelectedId() {
          return managerCtrl.getSelectedId();
        };

        // Afficher les nom et données sur la carte directement
        if ($scope.labels) {
          var _iterator = _createForOfIteratorHelper($scope.labels),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var label = _step.value;
              map.removeLayer(label);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        $scope.labels = [];
        _.extend($scope, {
          geojson: {
            data: infoMapCommune.features,
            onEachFeature: function onEachFeature(feature, layer) {
              var featureId = feature.properties.id;
              var style = geoManager.getGeoStyle(feature);
              if (featureId === getSelectedId()) {
                selectedLayer = layer;
                _.extend(style, geoConfig.selectedStyle);
              }
              if ($scope.reference != null && featureId === $scope.reference.id) {
                _.extend(style, geoConfig.referenceStyle);
              }
              layer.setStyle(style);
              layer.bindTooltip(tooltipElement, {
                sticky: true,
                direction: 'right',
                offset: [20, 0]
              });

              // Afficher les nom et données sur la carte directement
              // ajout de labels

              if ($scope.communeParams.label && map.getZoom() > 6) {
                var value = feature.properties.value;
                value = obsUtils.formatValue($scope.communeParams, value);
                var label = L.marker(layer.getBounds().getCenter(), {
                  icon: L.divIcon({
                    className: 'label-layer-carto',
                    html: '<div class="detail-carto"><div>' + feature.properties.nom + '</div><div>' + value + '</div></div>',
                    iconSize: [100, 40]
                  })
                }).addTo(map);
                $scope.labels.push(label);
              }
              layer.on("click", function (e) {
                // uniquement pour le public : changement de référence sur le click
                if (managerCtrl.getConfig().publicObs) {
                  selectArea(featureId, layer);
                  // sur le public, on ne recentre pas sur la référence suite au click pour ne pas déclencher de rechargement des contours
                  managerCtrl.loadReference(featureId, false);
                  managerCtrl.refreshData(); // La valeur pour la référence doit être mise à jour (TAEL-1163)
                } else if (featureId === getSelectedId()) {
                  managerCtrl.setSelectedId(null);
                  selectedLayer = null;
                  layer.setStyle(geoConfig.defaultStyle);
                } else {
                  selectArea(featureId, layer);
                }
              });
              layer.on("mouseover", function (e) {
                managerCtrl.setHoveredCommune(feature.properties);
                layer.setStyle(geoConfig.hoverStyle);
              });
              layer.on("mouseout", function (e) {
                managerCtrl.setHoveredCommune(null);
                if ($scope.reference != null && featureId === $scope.reference.id) {
                  layer.setStyle(geoConfig.referenceStyle);
                } else if (featureId === getSelectedId()) {
                  layer.setStyle(geoConfig.selectedStyle);
                } else {
                  layer.setStyle(geoConfig.defaultStyle);
                }
              });
            }
          }
        });
        var selectArea = function selectArea(featureId, layer) {
          if (selectedLayer) {
            selectedLayer.setStyle(geoConfig.defaultStyle);
          }
          managerCtrl.setSelectedId(featureId);
          selectedLayer = layer;
          layer.setStyle(geoConfig.selectedStyle);
        };
      };
    }]
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisMap.js", __webpack_require__(4), __webpack_require__(1), __webpack_require__(20)))

/***/ }),

/***/ 875:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisMapContextInfo", function () {
  return {
    restrict: "E",
    require: "^obsSdisManager",
    scope: true,
    replace: true,
    template: __webpack_require__(890)
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisMapContextInfo.js"))

/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisMapTooltip", ["obsUtils", function (obsUtils) {
  return {
    restrict: "E",
    require: "^obsSdisManager",
    scope: true,
    replace: true,
    template: "\n        <div class=\"leaflet-control control obs-map-tooltip\">\n            <div class=\"hovered-name-sdis\">{{hoverName}} </div>\n            <div class=\"hovered-categorie-sdis\"><span>Cat\xE9gorie</span> <span class=\"align-c certain-true-circle\">{{hoverCategorie}}</span></div>\n            <div class=\"hovered-value\">\n                {{referenceLabel}}: {{hoverValue}}\n            </div>\n        </div>",
    link: function link($scope, $el, $attrs, managerCtrl) {
      $scope.$watch(function () {
        return managerCtrl.getHoveredCommune();
      }, function (hoveredCommune) {
        if (hoveredCommune == null) {
          $scope.hoverName = null;
          $scope.hoverValue = null;
          $scope.hoverCategorie = null;
        } else {
          $scope.hoverName = hoveredCommune.nom + " (" + hoveredCommune.departement + ") ";
          $scope.hoverValue = obsUtils.formatValue($scope.communeParams, hoveredCommune.value);
          $scope.hoverCategorie = hoveredCommune.categorie;
        }
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisMapTooltip.js"))

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisPanel", ["applicationSettings", "$translate", "$http", "obsPanelService", "obsUtils", function (applicationSettings, $translate, $http, obsPanelService, obsUtils) {
  return {
    restrict: "E",
    replace: true,
    template: __webpack_require__(891),
    link: function link($scope, $el, $attrs) {
      $scope.optionsCollapsed = false;
      $scope.filtresCollapsed = true;
      $scope.datatypes = [{
        name: $translate('observatoire.datatype.Dette'),
        value: 'ENCOURS_DETTE'
      }, {
        name: $translate('observatoire.datatype.Annuite'),
        value: 'ANNUITE_DETTE'
      }, {
        name: $translate('observatoire.datatype.Amortissement'),
        value: 'AMORTISSEMENT_DETTE'
      }, {
        name: $translate('observatoire.datatype.Interet'),
        value: 'INTERET_DETTE'
      }];
      $scope.zonages = [{
        name: $translate('observatoire.zonage.France'),
        value: 'FRANCE'
      }];
      if (!$scope.observatoryConfig.publicObs) {
        $scope.zonages.push({
          name: $translate('observatoire.zonage.Panel'),
          value: 'PANEL'
        });
        obsPanelService.getPanels().then(function (panels) {
          $scope.panels = panels;
          if ($scope.panels.length > 0) {
            $scope.communeParams.panelId = $scope.panels[0].id;
          }
        });
      }
      $scope.representations = [{
        name: $translate('observatoire.representation.Absolu'),
        value: 'ABSOLU'
      }, {
        name: 'Par rapport à votre SDIS',
        value: 'RELATIF'
      }];
      $scope.unites = [{
        name: $translate('observatoire.unite.EnValeur'),
        value: 'VALEUR'
      }, {
        name: $translate('observatoire.unite.EnPourcentage'),
        value: 'POURCENTAGE'
      }];
      $scope.temporalites = [{
        name: $translate('observatoire.temporalite.Instantané'),
        value: 'INSTANTANE'
      }, {
        name: $translate('observatoire.temporalite.Evolution'),
        value: 'EVOLUTION'
      }];
      $scope.anneesDefaut = obsUtils.getAnneesDispo('sdis');
      $scope.annees = $scope.anneesDefaut;
      $scope.$watch('communeParams', function () {
        $scope.annees = $scope.anneesDefaut;
        if (!$scope.communeParams.anneeInstantane) {
          $scope.communeParams.anneeInstantane = obsUtils.getDerniereAnneeDispo();
        }
        if (!$scope.communeParams.anneeDebut) {
          $scope.communeParams.anneeDebut = obsUtils.getDerniereAnneeDispo() - 1;
        }
        if (!$scope.communeParams.anneeFin) {
          $scope.communeParams.anneeFin = obsUtils.getDerniereAnneeDispo();
        }
      }, true);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisPanel.js"))

/***/ }),

/***/ 878:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.directive("obsSdisSearchField", function () {
  return {
    restrict: "E",
    require: "^obsSdisManager",
    replace: true,
    template: '' + '<div class="obs-search-field">' + '   <tl-search-field config="searchConfig"></tl-search-field>' + '</div>',
    link: function link($scope, $el, $attrs, mapManagerCtrl) {
      var obsConfig = $scope.observatoryConfig,
        searchUrl = obsConfig.resourceBaseUrl + "/search";
      $scope.searchExtraParams = {
        actuelsSeulement: true
      };
      $scope.searchConfig = {
        labelAttribute: "nom",
        extraParams: "searchExtraParams",
        searchUrl: searchUrl,
        resultTemplate: "" + '<span class="name" ng-bind-html="result.nom | underlineSearchResultMatch:search.q"></span>' + '<span class="dept">{{result.departement}}</span>',
        onSelect: function onSelect(commune) {
          mapManagerCtrl.onSearchFieldSelection(commune);
        }
      };
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/maps/sdis/obsSdisSearchField.js"))

/***/ }),

/***/ 879:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);

// pas d'accès au panelService à partir de l'observatoire, on créé donc un service spécifique qui reprend les methoes réellement utilisées
ngModule.factory("obsPanelService", ["$modal", "$http", function ($modal, $http) {
  return {
    getPanels: function getPanels() {
      var urlPrefix = "/rest/panel";
      return $http.get(urlPrefix + "/list").then(function (result) {
        return result.data;
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/utils/obsPanelService.js"))

/***/ }),

/***/ 880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename, $, angular, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_getNgModule__ = __webpack_require__(0);




var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_getNgModule__["a" /* default */])(__filename);
ngModule.factory("obsStrateDefaultConfig", function () {
  return {
    defaultStyle: {
      weight: 2,
      opacity: 1,
      color: '#322f8f',
      dashArray: 3
    },
    hoverStyle: {
      color: "#F48600",
      dashArray: 0,
      weight: 4
    },
    selectedStyle: {
      color: "#46c014",
      dashArray: 0,
      weight: 5
    },
    referenceStyle: {
      color: "#A52694",
      dashArray: 0,
      weight: 5
    },
    noValueStyle: {
      fillOpacity: 0
    },
    gradientStops: ["#fffee9", "#fff9c8", "#ffe5b8", "#f7d3b3", "#e1c4b4", "#cebbb7"]
  };
});
ngModule.factory("ObsStratManager", ["$numberFormat", "colorUtils", "obsStrateDefaultConfig", function ($numberFormat, colorUtils, obsStrateDefaultConfig) {
  return function ObsStratManager(cfg) {
    var manager = this,
      config = $.extend(true, angular.copy(obsStrateDefaultConfig), cfg || {}),
      gradient,
      strates;
    var findStrateForValue = function findStrateForValue(value) {
      if (value == null || value === "HORS_FILTRE") {
        return config.noValueStyle;
      }
      var min, max;
      for (var i = strates.length - 1; i >= 0; i--) {
        min = strates[i].min;
        max = strates[i].max;

        // pour la prmiere state on est par exemple sur du <0. Donc on prend aussi le 0
        if (i === strates.length - 1 && min == null && max === value) {
          return strates[i];
        }
        if ((min == null || value >= min) && (max == null || value < max) || min === max && value === min) {
          return strates[i];
        }
      }
      return config.noValueStyle;
    };
    manager.setStrates = function (_strates) {
      gradient = colorUtils.generateGradient(config.gradientStops, _strates.length);
      strates = _.map(_strates, function (strate, i) {
        return _.extend(strate, {
          color: strate.color || gradient[i],
          fillOpacity: 0.7
        });
      });
    };
    manager.getGeoStyle = function (feature) {
      if (feature.properties.repere) {
        return _.extend({}, config.defaultStyle, {
          color: "#FF0000",
          fillOpacity: 0
        });
      }
      var value = feature.properties.value;
      var palier = findStrateForValue(value);
      var style = _.extend({}, config.defaultStyle, {
        fillColor: palier.color,
        fillOpacity: palier.fillOpacity
      });
      return style;
    };
    manager.generateLegend = function () {
      var legend = __WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.control({
        position: "bottomright"
      });
      legend.onAdd = function () {
        var div = $("<div>").addClass("control obs-legend");
        _.each(strates.reverse(), function (palier) {
          div.append('<div><i style="background:' + palier.color + '"></i>' + palier.label + '</div>');
        });
        return div[0];
      };
      return legend;
    };
    manager.getConfig = function () {
      return config;
    };
  };
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/utils/obsStratManager.js", __webpack_require__(4), __webpack_require__(3), __webpack_require__(1)))

/***/ }),

/***/ 881:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__filename) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_getNgModule__ = __webpack_require__(0);



var ngModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_getNgModule__["a" /* default */])(__filename);
ngModule.factory("obsUtils", ["$numberFormat", "$translate", function ($numberFormat, $translate) {
  /**
   * dernière année des données de la DGFIP. A augmenter après chaque récupération annuelle.
   */
  var DERNIERE_ANNEE_DGFIP_DISPONIBLE = 2025;
  var obsUtils = {
    getStrateLabel: function getStrateLabel(strate) {
      switch (strate) {
        case "MOINS_DE_500_HAB":
          return "- de 500 hab.";
        case "DE_500_A_2000_HAB":
          return "500 à 2000 hab.";
        case "DE_2000_A_3500_HAB":
          return "2 000 à 3 500 hab.";
        case "DE_3500_A_5000_HAB":
          return "3 500 à 5 000 hab.";
        case "DE_5000_A_10000_HAB":
          return "5 000 à 10 000 hab.";
        case "DE_10000_A_20000_HAB":
          return "10 000 à 20 000 hab.";
        case "DE_20000_A_50000_HAB":
          return "20 000 à 50 000 hab.";
        case "DE_50000_A_100000_HAB":
          return "50 000 à 100 000 hab.";
        case "PLUS_DE_100000_HAB_HORS_PARIS":
          return "+ de 100 000 hab..";
        case "HORS_STRATES":
          return null;
      }
      return "Strate inconnue :" + strate;
    },
    getTypeLabel: function getTypeLabel(datatype) {
      switch (datatype) {
        case "POPULATION_DGFIP":
          return "Population (DGFiP)";
        case "POPULATION_INSEE":
          return "Population  (INSEE)";
        case "POPULATION_DGCL_DGF":
          return "Population (DGF)";
        case "ENCOURS_DETTE":
          return "Dette";
        case "ENCOURS_DETTE_PAR_HABITANT":
          return "Dette par habitant";
        case "ANNUITE_DETTE":
          return "Annuité";
        case "ANNUITE_DETTE_PAR_HABITANT":
          return "Annuité par habitant";
        case "AMORTISSEMENT_DETTE":
          return "Amortissement";
        case "AMORTISSEMENT_DETTE_PAR_HABITANT":
          return "Amortissement par habitant";
        case "INTERET_DETTE":
          return "Intérêt";
        case "INTERET_DETTE_PAR_HABITANT":
          return "Intérêt par habitant";
        case "DOTATIONS":
          return "Dotation globale de fonctionnement";
        case "DOTATIONS_PAR_HABITANT":
          return "Dotation globale de fonctionnement par habitant";
        case "POTENTIEL_FINANCIER_PAR_HABITANT":
          return "Potentiel financier par habitant";
        case "DETTE_SUR_POTENTIEL_FINANCIER":
          return "Dette sur potentiel financier";
        case "RECETTES_FONCTIONNEMENT":
          return "Recette de fonctionnement";
        case "RECETTES_FONCTIONNEMENT_PAR_HABITANT":
          return "Recette de fonctionnement par habitant";
        case "DETTE_SUR_RECETTES_FONCTIONNEMENT":
          return "Dette sur recette de fonctionnnement";

        // sytale
        case "ACTIVITES":
          return "Dernière activités clotûrée";
        case "PRESTATAIRE_DETTE":
          return "Prestataire dette";
      }
      return $translate('of.indicateur.' + datatype);
    },
    getTypeUnit: function getTypeUnit(datatype, parHabitant) {
      switch (datatype) {
        case "POPULATION_DGFIP":
          return "habitants";
        case "POPULATION_INSEE":
          return "habitants";
        case "POPULATION_DGCL_DGF":
          return "habitants";
        case "DETTE_SUR_POTENTIEL_FINANCIER":
          return "mois";
        case "DETTE_SUR_RECETTES_FONCTIONNEMENT":
          return "mois";
        case "TAXE_HABITATION_TAUX":
          return "%";
        case "TAXE_FONCIERE_NON_BATIE_TAUX":
          return "%";
        case "COTISATION_FONCIERE_ENTREPRISES_TAUX":
          return "%";
        case "TAXE_FONCIERE_BATIE_TAUX":
          return "%";
        case "TAXE_ADDITIONNELLE_FONCIERE_NON_BATIE_TAUX":
          return "%";
        case "ACTIVITES":
          return " jours";
        case "PRESTATAIRE_DETTE":
          return "";
      }
      if (parHabitant) return "€/hab.";
      return "€";
    },
    formatValue: function formatValue(params, dataValue) {
      var formattedValue;
      var number = $numberFormat(dataValue);
      if (dataValue == null) {
        formattedValue = "Donnée non disponible";
      } else if (dataValue === "HORS_FILTRE") {
        formattedValue = "Hors filtre";
      } else {
        if (params.unite === 'POURCENTAGE') {
          formattedValue = number + " %";
        } else {
          if (params.representation === 'RELATIF' || params.temporalite === 'EVOLUTION') {
            formattedValue = (dataValue > 0 ? "+" : "") + number + " " + obsUtils.getTypeUnit(params.datatype, params.parHabitant);
          } else {
            formattedValue = number + " " + obsUtils.getTypeUnit(params.datatype, params.parHabitant);
          }
        }
      }
      return formattedValue;
    },
    getDerniereAnneeDispo: function getDerniereAnneeDispo() {
      return DERNIERE_ANNEE_DGFIP_DISPONIBLE;
    },
    /**
     * annees des indicateurs disponibles, hors Potentiel fiscal qui n'a pas les memes disponibilités.
     */
    getAnneesDispo: function getAnneesDispo(type) {
      var anneesDefaut = [];
      if (type === 'sdis') {
        for (var i = 2010; i <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; i++) {
          anneesDefaut.push(i);
        }
      } else if (type === 'departement') {
        for (var _i = 2008; _i <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; _i++) {
          anneesDefaut.push(_i);
        }
      } else {
        for (var _i2 = 2000; _i2 <= DERNIERE_ANNEE_DGFIP_DISPONIBLE; _i2++) {
          anneesDefaut.push(_i2);
        }
      }
      return anneesDefaut;
    }
  };
  return obsUtils;
}]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "src/modules/observatoire/ng/utils/obsUtils.js"))

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports = "<div class=\"obs-map obs-commune-map\"> <leaflet sizeable-component ng-if=\"mapConfig != null\" center=viewport geojson=geojson defaults=mapConfig.options maxbounds=mapConfig.maxbounds tiles=mapConfig.tiles></leaflet> </div> ";

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

module.exports = "<div> <img src=/images/shortcuts/guadeloupe-pink.png class=\"control shortcut\" title=Guadeloupe onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[16.19,-61.48],zoom:10}}))'/> <img src=/images/shortcuts/guyane-pink.png class=\"control shortcut\" title=Guyane onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[3.7,-53.36],zoom:8}}))'/> <img src=/images/shortcuts/martinique-pink.png class=\"control shortcut\" title=Martinique onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[14.62,-61.01],zoom:11}}))'/> <img src=/images/shortcuts/mayotte-pink.png class=\"control shortcut\" title=Mayotte onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[-12.83,45.15],zoom:11}}))'/> <img src=/images/shortcuts/reunion-pink.png class=\"control shortcut\" title=\"La Réunion\" onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[-21.12,55.51],zoom:11}}))'/> <img src=/images/shortcuts/france-pink.png class=\"control shortcut\" title=Métropole onclick='this.dispatchEvent(new CustomEvent(\"MapFocus\",{bubbles:!0,detail:{location:[46.5,2.5],zoom:7}}))'/> </div> ";

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> <p class=moy-label>Moyennes</p> <div class=\"val moy-val\" ng-if=\"strate!=null\">{{strate}} : {{strateValue}}</div> <div class=\"val moy-val\">Département ({{departementCodeInsee}}) : {{departementValue}}</div> <div class=\"val moy-val\">Nationale : {{paysValue}}</div> </div> ";

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

module.exports = "<div class=observatoire-carte-panel> <div class=reference> {{reference.name}} </div> <div ng-if=\"reference.id != null\"> <div class=tl-legend> Données principales {{annees[annees.length - 1]}} </div> <div class=tl-field> <div> <label>{{'observatoire.Dette' | translate}} </label> : <span>{{reference.encoursDette | number}} € ({{reference.encoursDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Annuite' | translate}} </label> : <span>{{reference.annuiteDette | number}} € ({{reference.annuiteDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Amortissement' | translate}} </label> : <span>{{reference.amortissementDette | number}} € ({{reference.amortissementDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Interet' | translate}} </label> : <span>{{reference.interetDette | number}} € ({{reference.interetDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Dotations' | translate}} </label> : <span>{{reference.dotationGlobale | number}} € ({{reference.dotationGlobaleParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.PopulationDGFIP' | translate}} </label> : <span>{{reference.populationDgfip | number}} hab.</span> </div> <div> <label>{{'observatoire.PotentielFinancierParHabitant' | translate}} </label> : <span>{{reference.potentielFinancierParHabitant| number}} €/hab</span> </div> <div> <label>{{'observatoire.RecetteDeFonctionnement' | translate}} </label> : <span>{{reference.recettesFonctionnement| number}} € ({{reference.recettesFonctionnementParHabitant| number}} €/hab)</span> </div> </div> </div> <div class=tl-fieldset> <div class=tl-legend> <span>Donnée affichée sur la carte</span> </div> <div> <div class=tl-field> <label class=tl-label>Etiquettes <i class=\"fa icon-tooltip-info\" tl-tooltip=\"Les étiquettes ne sont affichées que lorsque le niveau de zoom est suffisant pour permettre un affichage lisible.\"></i> <tl-checkbox ng-model=communeParams.label></tl-checkbox> </label> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Datatype' | translate}}</label> <select ng-model=communeParams.datatype ng-options=\"d.value as d.name for d in datatypes\"></select> </div> <div class=tl-field ng-if=isParHab(communeParams.datatype)> <label class=tl-label>Par habitant <tl-checkbox ng-model=communeParams.parHabitant></tl-checkbox> </label> </div> <div class=tl-field ng-if=!observatoryConfig.publicObs> <label class=tl-label>Source de population</label> <select ng-model=communeParams.sourcePopulation ng-options=\"d.value as d.name for d in sourcesPopulation\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Representation' | translate}}</label> <select ng-model=communeParams.representation ng-options=\"r.value as r.name for r in representations\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Temporalite' | translate}}</label> <select ng-model=communeParams.temporalite ng-options=\"t.value as t.name for t in temporalites\"></select> </div> <div class=tl-field ng-show=\"communeParams.temporalite === 'INSTANTANE'\"> <label class=tl-label>{{'observatoire.AnneeInstantane' | translate}}</label> <select ng-model=communeParams.anneeInstantane ng-options=\"a for a in annees\"></select> </div> <div ng-show=\"communeParams.temporalite === 'EVOLUTION'\"> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeDebut' | translate}}</label> <select ng-model=communeParams.anneeDebut ng-options=\"a for a in annees\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeFin' | translate}}</label> <select ng-model=communeParams.anneeFin ng-options=\"a for a in annees\"></select> </div> </div> <div class=tl-field ng-show=\"communeParams.representation=='RELATIF' || communeParams.temporalite == 'EVOLUTION'\"> <label class=tl-label>{{'observatoire.Unite' | translate}}</label> <select ng-model=communeParams.unite ng-options=\"u.value as u.name for u in unites\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Zonage' | translate}}</label> <select ng-model=communeParams.zonage ng-options=\"z.value as z.name for z in zonages\"></select> </div> <div ng-if=\"communeParams.zonage=='PANEL'\"> <div class=tl-field ng-if=\"panels && panels.length>0\"> <label class=tl-label>{{'observatoire.Panel' | translate}}</label> <select ng-model=communeParams.panelId ng-options=\"p.id as p.nom for p in panels\"></select> </div> <div ng-if=\"panels && panels.length==0\">Aucun panel de défini</div> </div> </div> </div> <div class=filters ng-if=!observatoryConfig.publicObs> <br> <div class=tl-fieldset> <div class=tl-legend> <span>{{'observatoire.Filtres' | translate}}</span> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMin' | translate}}</label> <input input-type-number number-integer ng-model=communeParams.populationMin> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMax' | translate}}</label> <input input-type-number number-integer ng-model=communeParams.populationMax> </div> </div> </div> </div> </div>";

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

module.exports = " <div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> </div> ";

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

module.exports = "<div class=observatoire-carte-panel> <div class=reference> {{reference.name}} </div> <div ng-if=\"reference.id != null\"> <div class=tl-legend> Données principales {{annees[annees.length - 1]}} </div> <div class=tl-field> <div> <label>{{'observatoire.Dette' | translate}} </label> : <span>{{reference.encoursDette | number}} € ({{reference.encoursDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Annuite' | translate}} </label> : <span>{{reference.annuiteDette | number}} € ({{reference.annuiteDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Amortissement' | translate}} </label> : <span>{{reference.amortissementDette | number}} € ({{reference.amortissementDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Interet' | translate}} </label> : <span>{{reference.interetDette | number}} € ({{reference.interetDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Dotations' | translate}} </label> : <span>{{reference.dotationGlobale | number}} € ({{reference.dotationGlobaleParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.PopulationDGFIP' | translate}} </label> : <span>{{reference.populationDgfip | number}} hab.</span> </div> <div> <label>{{'observatoire.RecetteDeFonctionnement' | translate}} </label> : <span>{{reference.recettesFonctionnement| number}} € ({{reference.recettesFonctionnementParHabitant| number}} €/hab)</span> </div> </div> </div> <div class=tl-fieldset> <div class=tl-legend> <span>Donnée affichée sur la carte</span> </div> <div class=tl-field> <label class=tl-label>Etiquettes <i class=\"fa icon-tooltip-info\" tl-tooltip=\"Les étiquettes ne sont affichées que lorsque le niveau de zoom est suffisant pour permettre un affichage lisible.\"></i> <tl-checkbox ng-model=communeParams.label></tl-checkbox> </label> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.Datatype' | translate}}</label> <select ng-model=communeParams.datatype ng-options=\"d.value as d.name for d in datatypes\"></select> </div> <div class=tl-field ng-if=isParHab(communeParams.datatype)> <label class=tl-label>Par habitant <tl-checkbox ng-model=communeParams.parHabitant></tl-checkbox> </label> </div> <div class=tl-field> <label class=tl-label>Source de population</label> <select ng-model=communeParams.sourcePopulation ng-options=\"d.value as d.name for d in sourcesPopulation\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Representation' | translate}}</label> <select ng-model=communeParams.representation ng-options=\"r.value as r.name for r in representations\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Temporalite' | translate}}</label> <select ng-model=communeParams.temporalite ng-options=\"t.value as t.name for t in temporalites\"></select> </div> <div class=tl-field ng-show=\"communeParams.temporalite === 'INSTANTANE'\"> <label class=tl-label>{{'observatoire.AnneeInstantane' | translate}}</label> <select ng-model=communeParams.anneeInstantane ng-options=\"a for a in annees\"></select> </div> <div ng-show=\"communeParams.temporalite === 'EVOLUTION'\"> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeDebut' | translate}}</label> <select ng-model=communeParams.anneeDebut ng-options=\"a for a in annees\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeFin' | translate}}</label> <select ng-model=communeParams.anneeFin ng-options=\"a for a in annees\"></select> </div> </div> <div class=tl-field ng-show=\"communeParams.representation=='RELATIF' || communeParams.temporalite == 'EVOLUTION'\"> <label class=tl-label>{{'observatoire.Unite' | translate}}</label> <select ng-model=communeParams.unite ng-options=\"u.value as u.name for u in unites\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Zonage' | translate}}</label> <select ng-model=communeParams.zonage ng-options=\"z.value as z.name for z in zonages\"></select> </div> <div ng-if=\"communeParams.zonage=='PANEL'\"> <div class=tl-field ng-if=\"panels && panels.length>0\"> <label class=tl-label>{{'observatoire.Panel' | translate}}</label> <select ng-model=communeParams.panelId ng-options=\"p.id as p.nom for p in panels\"></select> </div> <div ng-if=\"panels && panels.length==0\">Aucun panel de défini</div> </div> </div> </div> <div class=filters ng-if=!observatoryConfig.publicObs> <br> <div class=tl-fieldset> <div class=tl-legend> <span>{{'observatoire.Filtres' | translate}}</span> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMin' | translate}}</label> <input input-type-number number-integer ng-model=communeParams.populationMin> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMax' | translate}}</label> <input input-type-number number-integer ng-model=communeParams.populationMax> </div> </div> </div> </div> </div>";

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> </div> ";

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

module.exports = "<div class=observatoire-carte-panel> <div class=reference> {{reference.name}} </div> <div ng-if=\"reference.id != null\"> <div class=tl-legend> Données principales {{annees[annees.length - 1]}} </div> <div class=tl-field> <div> <label>{{'observatoire.Dette' | translate}} </label> : <span>{{reference.encoursDette | number}} € ({{reference.encoursDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Annuite' | translate}} </label> : <span>{{reference.annuiteDette | number}} € ({{reference.annuiteDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Amortissement' | translate}} </label> : <span>{{reference.amortissementDette | number}} € ({{reference.amortissementDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Interet' | translate}} </label> : <span>{{reference.interetDette | number}} € ({{reference.interetDetteParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.Dotations' | translate}} </label> : <span>{{reference.dotationGlobale | number}} € ({{reference.dotationGlobaleParHabitant| number}} €/hab)</span> </div> <div> <label>{{'observatoire.PopulationDGFIP' | translate}} </label> : <span>{{reference.populationDgfip | number}} hab.</span> </div> <div> <label>{{'observatoire.RecetteDeFonctionnement' | translate}} </label> : <span>{{reference.recettesFonctionnement| number}} € ({{reference.recettesFonctionnementParHabitant| number}} €/hab)</span> </div> </div> </div> <br> <div class=tl-fieldset> <div class=tl-legend> <span>Donnée affichée sur la carte</span> </div> <div class=tl-field> <label class=tl-label>Etiquettes <i class=\"fa icon-tooltip-info\" tl-tooltip=\"Les étiquettes ne sont affichées que lorsque le niveau de zoom est suffisant pour permettre un affichage lisible.\"></i> <tl-checkbox ng-model=epciParams.label></tl-checkbox> </label> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.Datatype' | translate}}</label> <select ng-model=epciParams.datatype ng-options=\"d.value as d.name for d in datatypes\"></select> </div> <div class=tl-field ng-if=isParHab(epciParams.datatype)> <label class=tl-label>Par habitant <tl-checkbox ng-model=epciParams.parHabitant></tl-checkbox> </label> </div> <div class=tl-field> <label class=tl-label>Source de population</label> <select ng-model=epciParams.sourcePopulation ng-options=\"d.value as d.name for d in sourcesPopulation\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Representation' | translate}}</label> <select ng-model=epciParams.representation ng-options=\"r.value as r.name for r in representations\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Temporalite' | translate}}</label> <select ng-model=epciParams.temporalite ng-options=\"t.value as t.name for t in temporalites\"></select> </div> <div class=tl-field ng-show=\"epciParams.temporalite === 'INSTANTANE'\"> <label class=tl-label>{{'observatoire.AnneeInstantane' | translate}}</label> <select ng-model=epciParams.anneeInstantane ng-options=\"a for a in annees\"></select> </div> <div ng-show=\"epciParams.temporalite === 'EVOLUTION'\"> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeDebut' | translate}}</label> <select ng-model=epciParams.anneeDebut ng-options=\"a for a in annees\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeFin' | translate}}</label> <select ng-model=epciParams.anneeFin ng-options=\"a for a in annees\"></select> </div> </div> <div class=tl-field ng-show=\"epciParams.representation=='RELATIF' || epciParams.temporalite == 'EVOLUTION'\"> <label class=tl-label>{{'observatoire.Unite' | translate}}</label> <select ng-model=epciParams.unite ng-options=\"u.value as u.name for u in unites\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Zonage' | translate}}</label> <select ng-model=epciParams.zonage ng-options=\"z.value as z.name for z in zonages\"></select> </div> <div ng-if=\"epciParams.zonage=='PANEL'\"> <div class=tl-field ng-if=\"panels && panels.length>0\"> <label class=tl-label>{{'observatoire.Panel' | translate}}</label> <select ng-model=epciParams.panelId ng-options=\"p.id as p.nom for p in panels\"></select> </div> <div ng-if=\"panels && panels.length==0\">Aucun panel de défini</div> </div> </div> </div> <br> <div class=tl-fieldset> <div class=tl-legend> <span>{{'observatoire.Filtres' | translate}}</span> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMin' | translate}}</label> <input input-type-number number-integer ng-model=epciParams.populationMin> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.PopulationMax' | translate}}</label> <input input-type-number number-integer ng-model=epciParams.populationMax> </div> </div> </div> </div>";

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

module.exports = "<div class=\"leaflet-control control obs-map-context-info\"> <p class=ref-label>{{referenceLabel}}</p> <div class=\"val ref-val\">{{reference.name}} : {{referenceValue}}</div> </div> ";

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

module.exports = "<div class=observatoire-carte-panel> <div class=reference> {{reference.name}} ({{reference.departement}}) </div> <div ng-if=\"reference.id != null\"> <div class=tl-legend> Données principales {{annees[annees.length - 1]}} </div> <div class=tl-field> <div> <label>{{'observatoire.Dette' | translate}} </label> : <span>{{reference.encoursDette | number}} €</span> </div> <div> <label>{{'observatoire.Annuite' | translate}} </label> : <span>{{reference.annuiteDette | number}} €</span> </div> <div> <label>{{'observatoire.Amortissement' | translate}} </label> : <span>{{reference.amortissementDette | number}} €</span> </div> <div> <label>{{'observatoire.Interet' | translate}} </label> : <span>{{reference.interetDette | number}} €</span> </div> </div> </div> <div class=tl-fieldset> <div class=tl-legend> <span>Donnée affichée sur la carte</span> </div> <div class=tl-field> <label class=tl-label>Etiquettes <i class=\"fa icon-tooltip-info\" tl-tooltip=\"Les étiquettes ne sont affichées que lorsque le niveau de zoom est suffisant pour permettre un affichage lisible.\"></i> <tl-checkbox ng-model=communeParams.label></tl-checkbox> </label> </div> <div> <div class=tl-field> <label class=tl-label>{{'observatoire.Datatype' | translate}}</label> <select ng-model=communeParams.datatype ng-options=\"d.value as d.name for d in datatypes\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Representation' | translate}}</label> <select ng-model=communeParams.representation ng-options=\"r.value as r.name for r in representations\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Temporalite' | translate}}</label> <select ng-model=communeParams.temporalite ng-options=\"t.value as t.name for t in temporalites\"></select> </div> <div class=tl-field ng-show=\"communeParams.temporalite === 'INSTANTANE'\"> <label class=tl-label>{{'observatoire.AnneeInstantane' | translate}}</label> <select ng-model=communeParams.anneeInstantane ng-options=\"a for a in annees\"></select> </div> <div ng-show=\"communeParams.temporalite === 'EVOLUTION'\"> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeDebut' | translate}}</label> <select ng-model=communeParams.anneeDebut ng-options=\"a for a in annees\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.AnneeFin' | translate}}</label> <select ng-model=communeParams.anneeFin ng-options=\"a for a in annees\"></select> </div> </div> <div class=tl-field ng-show=\"communeParams.representation=='RELATIF' || communeParams.temporalite == 'EVOLUTION'\"> <label class=tl-label>{{'observatoire.Unite' | translate}}</label> <select ng-model=communeParams.unite ng-options=\"u.value as u.name for u in unites\"></select> </div> <div class=tl-field> <label class=tl-label>{{'observatoire.Zonage' | translate}}</label> <select ng-model=communeParams.zonage ng-options=\"z.value as z.name for z in zonages\"></select> </div> <div ng-if=\"communeParams.zonage=='PANEL'\"> <div class=tl-field ng-if=\"panels && panels.length>0\"> <label class=tl-label>{{'observatoire.Panel' | translate}}</label> <select ng-model=communeParams.panelId ng-options=\"p.id as p.nom for p in panels\"></select> </div> <div ng-if=\"panels && panels.length==0\">Aucun panel de défini</div> </div> </div> </div> </div>";

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./map/obs-leaflet.less": 845,
	"./map/obs-search.less": 846,
	"./map/observatoire.less": 847
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 892;

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common/obsLeafletMap.js": 848,
	"./common/obsMapManager.js": 849,
	"./common/obsMapShortcut.js": 850,
	"./leaflet/leaflet-config.js": 851,
	"./leaflet/leaflet-loader.js": 852,
	"./leaflet/leaflet-utils.js": 853,
	"./leaflet/leaflet.js": 854,
	"./maps/commune/obsCommuneManager.js": 855,
	"./maps/commune/obsCommuneMap.js": 856,
	"./maps/commune/obsCommuneMapContextInfo.js": 857,
	"./maps/commune/obsCommuneMapTooltip.js": 858,
	"./maps/commune/obsCommunePanel.js": 859,
	"./maps/commune/obsCommuneSearchField.js": 860,
	"./maps/departement/obsDepartementManager.js": 861,
	"./maps/departement/obsDepartementMap.js": 862,
	"./maps/departement/obsDepartementMapContextInfo.js": 863,
	"./maps/departement/obsDepartementMapTooltip.js": 864,
	"./maps/departement/obsDepartementPanel.js": 865,
	"./maps/departement/obsDepartementSearchField.js": 866,
	"./maps/epci/obsEcpiSearchField.js": 867,
	"./maps/epci/obsEpciManager.js": 868,
	"./maps/epci/obsEpciMap.js": 869,
	"./maps/epci/obsEpciMapContextInfo.js": 870,
	"./maps/epci/obsEpciMapTooltip.js": 871,
	"./maps/epci/obsEpciPanel.js": 872,
	"./maps/sdis/obsSdisManager.js": 873,
	"./maps/sdis/obsSdisMap.js": 874,
	"./maps/sdis/obsSdisMapContextInfo.js": 875,
	"./maps/sdis/obsSdisMapTooltip.js": 876,
	"./maps/sdis/obsSdisPanel.js": 877,
	"./maps/sdis/obsSdisSearchField.js": 878,
	"./utils/obsPanelService.js": 879,
	"./utils/obsStratManager.js": 880,
	"./utils/obsUtils.js": 881
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 893;

/***/ })

},[2561]);


// WEBPACK FOOTER //
// app-observatoire.f6402325.js